export const advisorEs = {
  advisor: {
    title: "Legacy — Centro semanal de acciones Sentinel Advisor",
    subtitle: "Recomendaciones semanales y checklist de acciones",
    legacyProductBadge: "Legacy",
    cockpitTitle: "Gaucho",
    cockpitSubtitle: "Cabina supervisada de operaciones agrícolas",
    cockpitSafetyBadge: "Supervisado · sin ejecución",
    legacySectionNote:
      "Checklist semanal anterior conservado como referencia. La cabina supervisada de Gaucho es la vista principal.",
    refresh: "Actualizar recomendaciones",
    loading: "Analizando los datos de tu parcela...",
    selectParcel: "Selecciona una parcela",
    noParcels: "Aún no tienes parcelas registradas.",
    askInstead: "Preguntar por una parcela",
    placeholder: "Escribe el nombre de la parcela o pregunta (ej. 'Parcela Vill, riego')",
    send: "Enviar",
    priority: "Prioridad",
    cost: "Impacto coste",
    risk: "Riesgo",
    confidence: "Confianza",
    evidence: "Evidencia utilizada",
    missingData: "Datos faltantes",
    nextStep: "Siguiente paso",
    explain: "Explicar",
    openIrrigation: "Abrir Optimizador de Riego",
    openCropHealth: "Abrir Salud del Cultivo",
    openNotebook: "Abrir Cuaderno de Campo",
    openNitrogen: "Abrir Optimizador de Nitrógeno",
    openReports: "Abrir Centro de Informes",
    openPestDisease: "Abrir Plagas y Enfermedades",
    generateReport: "Generar informe",
    safetyDecisionSupport: "Soporte a la decisión — validar en campo antes de actuar.",
    error: "No se pudieron cargar las recomendaciones. Inténtalo de nuevo.",
    high: "Alta",
    medium: "Media",
    low: "Baja",
    demoBadge: "Demo — datos de muestra",
    noParcelTitle: "Ninguna parcela seleccionada",
    noParcelMessage: "Selecciona una parcela para generar recomendaciones específicas.",
    selectParcelBtn: "Seleccionar parcela",
    openParcels: "Abrir parcelas",
    portfolioBadge: "Recomendación a nivel de portfolio",
    appliesTo: "Aplica a",
    appliesToAllParcels: "todas las parcelas con datos suficientes",
    appliesToNParcels: "{{count}} parcelas",
    openVegetationIndices: "Abrir Índices de Vegetación",
    openSatelliteMonitoring: "Abrir Monitorización Satélite",
    unavailableTitle: "Sentinel Advisor temporalmente no disponible",
    unavailableMessage: "No hemos podido cargar recomendaciones ahora mismo. Puedes revisar tus parcelas o abrir el Centro de Informes.",
    selectParcelLabel: "Selecciona una parcela",
    analyzeParcel: "Analizar parcela",
    noParcelsTitle: "Aún no tienes parcelas",
    noParcelsMessage: "Crea tu primera parcela para usar Sentinel Advisor.",
    addParcel: "Añadir parcela",
    parcelNotFound: "Parcela seleccionada no encontrada o sin acceso.",
    evidenceAvailable: "Evidencia disponible",
    costSavingGuidance: "Guía para ahorrar coste",
    doNotConclude: "Qué no concluir",
    openVegetationIndicesShort: "Índices de Vegetación",
    createFieldObservation: "Crear observación de campo",
    generateMonitoringReport: "Generar informe de monitorización",
    requiredToImprove: "Necesario para mejorar esta recomendación",
    requiredToImproveHint: "Para darte una recomendación completa, Sentinel Advisor necesita actualizar la imagen satelital, recalcular FAO-56 ET0/ETc y refrescar la previsión meteorológica de 7 días. Abre los módulos siguientes para actualizar o validar los datos faltantes.",
    openNdviZones: "Abrir Zonas NDVI",
    openSplitView: "Abrir Vista Comparada",
    openIrrigationReports: "Abrir Informes de Riego",
    openDrought: "Abrir Estrés Hídrico / Sequía",
    openDiseaseRiskMap: "Abrir Mapa de Riesgo de Enfermedades",
    openPK: "Abrir Optimizador P&K",
    openFoliar: "Abrir Análisis Foliar",
    openParcelPassport: "Abrir Pasaporte de Parcela",
    openTraceability: "Abrir Trazabilidad",
    openAlerts: "Abrir Alertas",
    openCalendar: "Abrir Calendario",
    weeklyActionCenter: "Centro semanal de acciones",
    statusPending: "Pendiente de revisión",
    statusBlocked: "Bloqueada — faltan datos",
    statusAccepted: "Aceptada",
    statusCompleted: "Completada",
    statusDismissed: "Descartada",
    statusExpired: "Expirada",
    openAgain: "Abrir de nuevo",
    allActionsCompleted: "Todas las acciones recomendadas para esta recomendación se han completado.",
    requiredToComplete: "Necesario para completar la recomendación",
    actionRefresh: "Abrir módulo para refrescar datos",
    actionRecalculate: "Abrir módulo para recalcular",
    actionCreateTask: "Crear tarea de exploración",
    actionCreateObservation: "Crear observación de campo",
    actionGenerateReport: "Generar informe",
    actionReanalyze: "Reanalizar parcela",
    actionOpenModule: "Abrir módulo",
    accept: "Aceptar",
    dismiss: "Descartar",
    markDone: "Marcar hecho",
    markReviewed: "Marcar como revisado",
    undo: "Deshacer",
    manualChip: "Manual",
    activityLog: "Registro de actividad",
    actionUnavailableHint: "Automatización aún no disponible — abre el módulo para hacerlo manualmente.",
    actionChecklist: "Lista de acciones",
    secondaryActions: "Más módulos",
    actionOpenNotebookCreateObservation: "Abrir cuaderno de campo para crear observación",
    actionOpenReportsGenerate: "Abrir Centro de Informes para generar informe",
    reviewedHint: "Confirmaciones manuales realizadas por el usuario.",
    evtCreated: "Recomendación creada",
    evtOpenedModule: "El usuario abrió el módulo",
    evtMarkedDone: "Acción requerida marcada como hecha",
    evtAccepted: "Recomendación aceptada",
    evtDismissed: "Recomendación descartada",
    evtAwaitingData: "Esperando datos actualizados",
    evtReanalyzed: "Recomendación reanalizada",
    evtMissingNdvi: "Datos satelitales (NDVI) faltantes o desactualizados",
    evtMissingEt0: "Datos FAO-56 ET0/ETc faltantes o desactualizados",
    evtMissingWeather: "Previsión meteorológica faltante o desactualizada",
    actionDoneToast: "Acción marcada como hecha",
    actionFailedToast: "No se pudo actualizar la recomendación",
    lastAnalysis: "Último análisis",
    justNow: "hace instantes",
    minAgo: "hace {{n}} min",
    refreshShort: "Actualizar",
    chkReviewSatellite: "Revisar datos satelitales",
    chkReviewIrrigation: "Revisar datos de riego",
    chkAddObservation: "Añadir observación de campo",
    chkGenerateReport: "Generar informe manualmente",
    chkReviewModule: "Revisar módulo recomendado",
    chkRefreshEt0: "Refrescar ET0 / cálculo FAO-56",
    chkRefreshWeather: "Refrescar previsión meteorológica de 7 días",
    chkRefreshNdvi: "Revisar o actualizar datos satelitales de vegetación",
    chkReviewIrrigationRec: "Revisar la recomendación de riego",
    chkGenerateEvidenceReport: "Generar informe de decisiones",
    chkGeneratePartialEvidenceReport: "Generar informe parcial de evidencia",
    et0ReviewedButMissing: "Se revisó la actualización de ET0, pero todavía no hay datos frescos de ET0.",
    forecastReviewedButMissing: "Se revisó la actualización de la previsión, pero todavía no hay una previsión fresca de 7 días.",
    chkReviewVegetationIndices: "Revisar índices de vegetación",
    ctaRefreshEt0AndForecast: "Refrescar ET0 y previsión",
    ctaRefreshEt0: "Refrescar ET0",
    ctaRefreshWeather: "Refrescar previsión",
    ctaRefreshNdvi: "Refrescar imagen satelital",
    ctaReviewVegetationIndices: "Revisar índices de vegetación",
    manualRefreshNote: "Estos datos deben refrescarse desde el módulo vinculado.",
    refreshWeatherNow: "Refrescar previsión ahora",
    refreshWeatherInProgress: "Refrescando previsión…",
    refreshWeatherDone: "Previsión a 7 días actualizada",
    refreshWeatherFailed: "No se pudo refrescar la previsión. Inténtalo de nuevo.",
    refreshWeatherMissingCoords: "La parcela no tiene coordenadas — ábrela en Parcelas para definir su ubicación.",
    opensIrrigationOptimizer: "Abre el Optimizador de Riego.",
    opensSatelliteMonitoring: "Abre la Monitorización Satélite.",
    opensReportsCenter: "Abre el Centro de Informes.",
    opensFieldNotebook: "Abre el Cuaderno de Campo.",
    opensVegetationIndices: "Abre los Índices de Vegetación.",
    needsRefreshChip: "Necesita refrescar",
    moduleRequiredChip: "Módulo requerido",
    expandAdvisor: "Ampliar ventana",
    collapse: "Reducir ventana",
    expandWindow: "Ampliar ventana",
    shrinkWindow: "Reducir ventana",
    actionsPending: "{{n}} acciones pendientes",
    secActionRecommendation: "Recomendación",
    secActionEvidence: "Evidencia",
    secActionMissing: "Datos faltantes o desactualizados",
    secActionRecommendedAction: "Acción recomendada",
    secActionSupporting: "Módulos de apoyo",
    secActionChecklist: "Lista de acciones",
    secActionWorkflow: "Flujo de trabajo",
    secActionActivityLog: "Registro de actividad",
    workflowDescription: "Gestiona el estado de esta recomendación. Estos controles no ejecutan operaciones de campo automáticamente.",
    acceptTooltip: "Confirma que esta recomendación es relevante y debe mantenerse activa.",
    dismissTooltip: "Descarta esta recomendación. No se priorizará salvo que nuevos datos cambien el análisis.",
    reanalyzeTooltip: "Ejecuta de nuevo el análisis usando los últimos datos disponibles de la parcela.",
    workflowFooterNote: "Estos controles gestionan el estado de la recomendación. Las acciones operativas se completan desde los módulos vinculados o marcando los elementos del checklist como revisados.",
    templates: {
      ndvi: {
        inspect_low_vigor: "Inspecciona la zona de bajo vigor {{zone_id}} (NDVI mínimo {{min_ndvi}}). Recorre el área y confirma los síntomas en campo antes de sacar conclusiones.",
        trend_review: "Revisa la tendencia de NDVI / NDRE de los últimos {{window_days}} días y compárala con el ciclo anterior antes de programar cualquier operación de campo.",
      },
      fao56: {
        irrigation_quantified: "La demanda hídrica de referencia del cultivo (ETc) es {{etc_mm_per_day}} mm/día durante los próximos {{horizon_days}} días. Es evidencia de evapotranspiración del cultivo para revisión y no una cantidad de riego a aplicar.",
        irrigation_validate_first: "Actualiza la previsión meteorológica en vivo y registra el último riego aplicado. La ETc describe la demanda hídrica del cultivo y no define una cantidad de riego a aplicar.",
        collect_irrigation_log: "Registra los riegos recientes en el Cuaderno de Campo para mantener completa la evidencia del balance hídrico. No se produce ninguna cantidad de riego a aplicar.",
        risk_outlook_water_stress: "Monitorea un posible estrés hídrico si las lluvias siguen siendo limitadas. La evidencia actual está incompleta porque faltan los registros de riego aplicado y la previsión meteorológica en vivo.",
      },
      sar: {
        descriptive_only_note: "La señal de humedad del suelo de Sentinel-1 SAR es solo descriptiva. No puede usarse por sí sola para activar un riego — valida en campo.",
      },
      pest: {
        scouting_priority: "Hay {{alert_count}} alerta(s) de plagas o enfermedades en esta parcela. Prioriza la exploración de campo y valida los síntomas antes de decidir cualquier tratamiento.",
        not_evaluated_window: "El riesgo de plagas y enfermedades no ha sido evaluado para esta ventana de informe. Se requiere exploración de campo antes de sacar conclusiones.",
        routine_scouting_no_active_alerts: "No hay alertas activas de plagas o enfermedades en los datos evaluados disponibles. Continúa con la exploración rutinaria de campo.",
      },
      soil: {
        collect_lab_data: "No hay análisis de suelo o laboratorio persistido. Sube un análisis reciente para que el agente pueda calcular una recomendación nutricional.",
      },
      weather: {
        forecast_incomplete: "La previsión meteorológica a 7 días está incompleta. Actualiza la previsión para que el agente pueda evaluar la demanda atmosférica.",
        frost_prep: "Se espera una temperatura mínima de {{min_temp_c}} °C el {{event_date}}. Prepara medidas de protección contra heladas y valida la exposición en campo.",
      },
    },
    autonomy: {
      direct_action: "Acción directa",
      field_validation_required: "Requiere validación en campo",
      data_required: "Faltan datos",
      blocked: "Bloqueada — sin señal",
    },
    actionPlan: {
      sectionTitle: "Plan de Acción Agronómico Autónomo",
      betaBadge: "Beta — determinista, con evidencia",
      action: "Acción",
      priority: "Prioridad",
      autonomy: "Autonomía",
      module: "Módulo",
      evidenceUsed: "Referencia de evidencia",
      evidenceMissing: "Evidencia faltante",
      doNotConclude: "No concluir",
      none: "No se pudieron emitir acciones autónomas: la evidencia es insuficiente.",
    },
    dataSummaryHeading: "Resumen de datos y recomendaciones",
    dataSummarySubtitle: "Contexto de apoyo — el Plan de Acción Agronómico Autónomo de arriba es la capa de acción para el agricultor.",
    readiness: {
      heading: "Disponibilidad de datos",
      et0Stale: "ET0/ETc no actualizada — abre el Optimizador de Riego para refrescar el cálculo FAO-56.",
      et0Missing: "ET0/ETc no disponible para esta parcela — abre el Optimizador de Riego para ejecutar el cálculo FAO-56.",
      forecastStale: "Pronóstico a 7 días no actualizado para esta parcela — abre Clima y Condiciones para refrescar el pronóstico.",
      forecastMissing: "Pronóstico a 7 días no disponible para esta parcela — abre Clima y Condiciones para refrescar el pronóstico.",
      et0Current: "Última ET0: FAO-56 diaria, actualizada {{date}}.",
      forecastCurrent: "Último pronóstico: pronóstico meteorológico, actualizado {{date}}.",
      openIrrigationOptimizer: "Abrir Optimizador de Riego",
      openWeatherConditions: "Abrir Clima y Condiciones",
    },
    legacyBadge: "Recomendación heredada",
    legacyHint: "Generada por el pipeline anterior del Asesor. Gaucho (arriba) es la lectura autorizada.",
    statusReviewRequired: "Revisión requerida",
    statusSupersededByFarmOps: "Sustituida por Gaucho",
    etcInvalidInline: "ETc inválida — refrescar cálculo FAO-56",
    et0InvalidInline: "ET0 inválida — refrescar cálculo FAO-56",
    lifecycle: {
      sectionTitle: "Ciclo del Cultivo y Planificación Post-Cosecha",
      sectionSubtitle: "Preguntas estructuradas para planificar la restauración del suelo tras la cosecha. En esta beta no se recomienda ninguna especie ni mezcla de cubierta.",
      betaBadge: "Beta — determinista, con evidencia",
      priority: "Prioridad",
      evidenceUsed: "Evidencia utilizada",
      evidenceMissing: "Evidencia faltante",
      doNotConclude: "No concluir",
      persistenceNote: "Entrada de planificación — la persistencia llegará en la próxima fase.",
      priorityValues: { low: "Baja", medium: "Media", high: "Alta" },
      autonomy: {
        data_required: "Faltan datos",
        field_validation_required: "Requiere validación en campo",
        blocked: "Bloqueada — sin señal",
      },
      state: {
        active_crop: "Cultivo activo",
        near_harvest: "Próximo a cosecha",
        harvested_confirmed: "Cosechado (confirmado)",
        post_harvest_window: "Ventana post-cosecha",
        unknown: "Desconocido",
      },
      templates: {
        "lifecycle.confirm_harvest_status": {
          title: "Verificación del ciclo del cultivo",
          message: "No pudimos confirmar la fase del cultivo con la evidencia disponible. Confirma el estado de la cosecha para habilitar la planificación post-cosecha.",
        },
        "lifecycle.declare_next_crop": {
          title: "Cultivo siguiente requerido",
          message: "Declara el próximo cultivo previsto para poder evaluar la planificación post-cosecha.",
        },
        "lifecycle.declare_post_harvest_objective": {
          title: "Objetivo post-cosecha",
          message: "Declara tu principal objetivo post-cosecha para que el agente prepare los datos de planificación.",
        },
        "lifecycle.planning_ready_pending_field_validation": {
          title: "Planificación post-cosecha lista",
          message: "Los datos de planificación post-cosecha están disponibles. Se requiere validación en campo antes de recomendar cualquier estrategia de cubierta vegetal.",
        },
      },
      questions: {
        confirm_harvest_status: "¿Se ha cosechado el cultivo principal?",
        declare_next_crop: "¿Cuál es el próximo cultivo previsto?",
        declare_post_harvest_objective: "¿Cuál es tu principal objetivo post-cosecha?",
      },
      options: {
        harvested_confirmed: "Cosechado",
        near_harvest: "Próximo a cosecha",
        active_crop: "Aún activo",
        unknown: "No estoy seguro",
        nitrogen_fixation: "Fijación de nitrógeno",
        erosion_control: "Control de erosión",
        soil_structure: "Estructura del suelo",
        weed_suppression: "Supresión de malas hierbas",
        biodiversity: "Biodiversidad",
        organic_matter: "Materia orgánica",
        moisture_conservation: "Conservación de humedad",
      },
      missing: {
        harvest_status: "Estado de la cosecha",
        next_crop: "Próximo cultivo previsto",
        post_harvest_objective: "Objetivo post-cosecha",
        forecast_7d: "Previsión a 7 días",
        soil_analysis: "Análisis de suelo / laboratorio",
      },
      doNotConcludeItems: {
        cover_crop_species: "Especie de cubierta vegetal",
        cover_crop_mix: "Mezcla de cubierta vegetal",
        soil_restoration_guarantee: "Garantía de restauración del suelo",
        fertilizer_prescription: "Prescripción de fertilizante",
        pesticide_prescription: "Prescripción de fitosanitario",
      },
    },
    farmOps: {
      emptyEvidence: {
        title: "Gaucho est\u00e1 listo, pero a\u00fan no tiene evidencia confirmada",
        subtitle:
          "La parcela est\u00e1 seleccionada y el panel est\u00e1 cargado. Nada de lo siguiente se genera ni se supone: Gaucho solo muestra lo que realmente puede leer hoy.",
        whyLimited:
          "Todav\u00eda no se pudo generar un informe operativo determinista para esta parcela, por lo que las sugerencias supervisadas se mantienen limitadas hasta que existan los datos requeridos.",
        errorPrefix: "Problema al cargar datos",
      },
      globalSupervisionNote:
        "Asistente supervisado: cada elemento requiere revisión humana; nada se ejecuta automáticamente.",
      sections: {
        briefPriorities: "Resumen completo y prioridades",
        needsFromYou: "Lo que Gaucho necesita de ti",
        preparationReadiness: "Preparación y disponibilidad",
        actionPlanDetail: "Plan de acción y observaciones",
        recommendationsModuleStatus: "Recomendaciones y estado de módulos",
        evidenceDetail: "Contexto detallado de evidencia",
        supervisedPackages: "Paquetes de acción supervisada",
        historyRotation: "Historial de parcela y rotación",
        boundaries: "Alcance y límites",
        evidenceContext: "Contexto de evidencia",
        modules: "Módulos del panel conectados",
        updateGuide: "Cómo actualizar tus datos",
      },
      today: {
        title: "Hoy",
        globalStatus: {
          operational: "Operativo",
          attention: "Requiere atención",
          limited: "Limitado por evidencia",
          blocked: "Bloqueado",
        },
        evidenceConflict: "Evidencia contradictoria: requiere revisión",
        irrigationNotNeededYet: "El riego aún no es necesario",
        additionalEvidenceNote:
          "Son elementos adicionales que faltan. La decisión de riego sigue bloqueada por el bloqueo canónico indicado arriba.",
        noPriorities: "Hoy no hay ninguna prioridad operativa pendiente de revisión.",
        viewFullBrief: "Ver el resumen completo y las prioridades",
      },
      commercialCockpit: {
        title: "Cabina de operaciones de Gaucho",
        subtitle:
          "Una vista supervisada de lo que Gaucho sabe de esta parcela, qué módulos del panel lee hoy, qué falta todavía y qué pasos de revisión seguros puede sugerir.",
        badge: "Asistente supervisado",
        parcelLabel: "Parcela",
        noParcel: "Selecciona una parcela para cargar la cabina.",
        summaryTitle: "Resumen operativo",
        modulesTitle: "Módulos del panel conectados",
        modulesSubtitle:
          "El estado se deriva solo de rutas de lectura reales. Aquí no se genera ni se supone nada.",
        knowsTitle: "Lo que Gaucho sabe ahora",
        knowsEmpty: "Gaucho todavía no tiene evidencia confirmada para esta parcela.",
        needsTitle: "Lo que Gaucho necesita a continuación",
        needsEmpty: "Ahora mismo no falta evidencia obligatoria.",
        nextStepTitle: "Siguiente paso seguro",
        nextStepEmpty: "Todavía no hay un siguiente paso seguro para esta parcela.",
        demoTitle: "Preparación para demo comercial",
        demoLevels: {
          not_ready: "No preparada — conecta primero más evidencia de la parcela",
          partial: "Parcialmente preparada — algunos módulos aún necesitan datos",
          demo_ready: "Lista para demo — los módulos principales leen evidencia real",
        },
        cannotTitle: "Lo que Gaucho no puede hacer",
        cannot: {
          no_execution:
            "Gaucho nunca realiza operaciones de campo en tu nombre.",
          no_product_or_rate:
            "Gaucho nunca indica insumos, cantidades ni cifras por hectárea.",
          no_treatment_instruction:
            "Gaucho nunca emite instrucciones fitosanitarias ni de nutrición.",
          no_machinery_operation:
            "Gaucho nunca activa, programa ni despacha maquinaria o equipos de riego.",
          no_claim_or_submission:
            "Gaucho nunca presenta siniestros ni trámites legales, de seguros o administrativos.",
          no_auto_analysis_run:
            "Gaucho nunca ejecuta por su cuenta análisis de riesgo de pago ni cálculos de fertilidad.",
        },
        openModule: "Abrir módulo",
        supervisedNote:
          "Cada sugerencia siguiente es un paso de revisión humana. Tú mantienes el control de cada decisión de campo.",
      },
      moduleStatus: {
        connected: "Conectado",
        available: "Disponible",
        limited: "Limitado",
        missing: "Faltan datos",
        review_only: "Solo revisión",
        not_connected: "No conectado",
        blocked: "Fuera de alcance",
        descriptions: {
          connected: "Gaucho lee hoy datos reales de la parcela desde este módulo.",
          available: "Los datos existen y el módulo se puede abrir, pero Gaucho no los resume.",
          limited: "Solo hay contexto parcial disponible; Gaucho enlaza en lugar de concluir.",
          missing: "Este módulo está conectado a Gaucho pero aún no tiene datos de esta parcela.",
          review_only: "Módulo sensible — Gaucho lo referencia, nunca concluye a partir de él.",
          not_connected: "Todavía no hay un resultado guardado a nivel de parcela; ejecuta el módulo manualmente.",
          blocked: "No forma parte de la experiencia agrícola de cultivo.",
        },
      },
      sidebarIntegration: {
        title: "Cobertura del menú lateral",
        groups: {
          dashboard: "Panel",
          parcel: "Parcela",
          monitor: "Monitorizar",
          risk: "Riesgo",
          decide: "Decidir",
          report: "Informes",
          prove: "Trazabilidad",
        },
      },
      connectedModules: {
        title: "Cuadrícula de módulos",
        modules: {
          overview: "Vista general",
          multi_farm: "Vista multi-explotación",
          manage_parcels: "Gestionar parcelas",
          field_notebook: "Cuaderno de campo",
          calendar: "Calendario",
          seasons: "Campañas",
          satellite_images: "Imágenes satelitales",
          vegetation_indices: "Índices de vegetación",
          ndvi_zones: "Zonas NDVI",
          weather_conditions: "Clima y condiciones",
          phenology: "Inteligencia fenológica",
          foliar_analysis: "Análisis foliar",
          agronomy_tools: "Herramientas agronómicas",
          alerts: "Alertas",
          drought_water_stress: "Sequía y estrés hídrico",
          pest_disease: "Riesgo de plagas y enfermedades",
          frost_protection: "Protección contra heladas",
          fire_detection: "Detección de incendios",
          agronomic_risk_ml: "Evaluación de riesgo agronómico",
          economic_risk: "Impacto económico del riesgo",
          irrigation_optimizer: "Optimizador de riego",
          irrigation_reports: "Informes de riego",
          nitrogen_optimizer: "Optimizador de nitrógeno",
          pk_optimizer: "Optimizador P&K",
          vra_builder: "Constructor rendimiento-VRA",
          reports_center: "Centro de informes",
          compliance_readiness: "Comprobación de cumplimiento",
          parcel_passport: "Registro digital de parcela",
        },
        updateSteps: {
          overview: "Completa la configuración de la parcela.",
          multi_farm: "Confirma tus parcelas y sus límites.",
          manage_parcels: "Actualiza el límite y confirma el cultivo.",
          field_notebook: "Añade una observación de campo.",
          calendar: "Revisa el calendario manualmente.",
          seasons: "Crea o confirma la campaña activa.",
          satellite_images: "Revisa las imágenes más recientes.",
          vegetation_indices: "Consulta la tendencia del índice y valida las anomalías.",
          ndvi_zones: "Valida en campo las zonas de bajo vigor.",
          weather_conditions: "Revisa el contexto meteorológico.",
          phenology: "Actualiza la campaña activa para afinar la estimación del estado.",
          foliar_analysis: "Añade o actualiza un registro de análisis foliar.",
          agronomy_tools: "Abre manualmente la herramienta correspondiente.",
          alerts: "Revisa las alertas activas.",
          drought_water_stress: "Revisa el contexto de sequía y estrés hídrico.",
          pest_disease: "Valida los síntomas con una observación de campo.",
          frost_protection: "Revisa el contexto de riesgo de heladas.",
          fire_detection: "Revisa la evidencia de incendios.",
          agronomic_risk_ml: "Ejecuta manualmente la evaluación de riesgo para generar contexto.",
          economic_risk: "Abre manualmente la vista de impacto económico.",
          irrigation_optimizer: "Actualiza ET, lluvia y el registro de riego.",
          irrigation_reports: "Genera un informe de riego.",
          nitrogen_optimizer: "Añade evidencia de suelo o foliar y abre el optimizador.",
          pk_optimizer: "Añade evidencia de suelo o foliar y abre el optimizador.",
          vra_builder: "Revisa el constructor manualmente.",
          reports_center: "Genera un informe de evidencia.",
          compliance_readiness: "Revisa la comprobación de cumplimiento.",
          parcel_passport: "Prepara la evidencia de trazabilidad.",
        },
      },
      safeRecommendations: {
        title: "Recomendaciones supervisadas seguras",
        subtitle:
          "Pasos de revisión derivados de evidencia real de los módulos. Ninguno es una instrucción para actuar en campo.",
        empty: "Todavía no hay recomendaciones supervisadas para esta parcela.",
        safetyNote: "Requiere revisión humana. Gaucho no lo realiza por ti.",
        reviewOnlyNote:
          "Módulo sensible — Gaucho solo puede pedirte que lo revises con un agrónomo cualificado.",
        types: {
          evidence_review: "Revisar evidencia",
          module_review: "Revisar módulo",
          missing_data_update: "Actualizar datos que faltan",
          field_validation: "Validar en campo",
          report_generation: "Generar informe",
          qualified_review_required: "Requiere revisión cualificada",
          manual_optimizer_review: "Revisar el optimizador manualmente",
          risk_context_review: "Revisar contexto de riesgo",
          traceability_review: "Revisar trazabilidad",
        },
        typeDescriptions: {
          evidence_review: "Comprueba la evidencia guardada antes de tomar una decisión.",
          module_review: "Abre el módulo y revísalo manualmente.",
          missing_data_update: "Añade la información que falta para que Gaucho tenga mejor contexto.",
          field_validation: "Confirma en campo lo que sugieren los datos con tu propia observación.",
          report_generation: "Genera un informe de evidencia antes de compartir esta parcela externamente.",
          qualified_review_required: "Pide a un agrónomo cualificado que lo revise antes de decidir.",
          manual_optimizer_review: "Abre tú mismo el optimizador y revisa las cifras de la parcela.",
          risk_context_review: "Revisa manualmente el contexto de riesgo no vinculante.",
          traceability_review: "Revisa el registro de trazabilidad para comprobar que está completo.",
        },
      },
      updateDataGuide: {
        title: "Cómo actualizar la información que Gaucho necesita",
        subtitle:
          "Gaucho solo lee lo que tú has guardado. Actualiza estas áreas para desbloquear pasos de revisión con mejor evidencia.",
        footerNote:
          "Actualizar datos nunca habilita la ejecución. Gaucho sigue siendo un asistente supervisado.",
        items: {
          parcel: {
            label: "Datos de la parcela",
            desc: "Confirma el límite, el cultivo y la superficie en Gestionar parcelas.",
          },
          season: {
            label: "Datos de campaña",
            desc: "Crea o confirma la campaña activa con su fecha de siembra.",
          },
          satellite: {
            label: "Datos satelitales y de vegetación",
            desc: "Abre las páginas de imágenes e índices para que haya observaciones recientes.",
          },
          weather: {
            label: "Datos de clima, agua y riego",
            desc: "Mantén al día ET, lluvia y el registro de riego de la parcela.",
          },
          soil: {
            label: "Datos de suelo y foliares",
            desc: "Añade o actualiza los registros de análisis de suelo y foliar.",
          },
          risk: {
            label: "Datos de riesgo y económicos",
            desc: "Ejecuta manualmente la evaluación de riesgo agronómico cuando necesites ese contexto.",
          },
          fertility: {
            label: "Revisión del optimizador de fertilidad",
            desc: "Abre tú mismo los optimizadores de nitrógeno y P&K y revisa las cifras.",
          },
          observations: {
            label: "Observaciones de campo y cuaderno",
            desc: "Registra lo que ves en campo para que Gaucho alinee los datos con la realidad.",
          },
          reports: {
            label: "Informes y evidencia",
            desc: "Genera un informe de evidencia cuando necesites compartir la parcela externamente.",
          },
          compliance: {
            label: "Cumplimiento y registro digital de parcela",
            desc: "Revisa la comprobación de cumplimiento y el registro digital de parcela.",
          },
          actionPlan: {
            label: "Plan de acción y revisión supervisada",
            desc: "Acepta, avanza y revisa el plan de acción para que la auditoría supervisada quede completa.",
          },
        },
      },
      sectionTitle: "Gaucho — Asistente de operaciones agrícolas",
      sectionSubtitle: "Asistente supervisado de operaciones agrícolas basado en evidencia, centrado en la eficiencia de recursos.",
      productMessage: "Gaucho ayuda a hacer cada parcela más eficiente convirtiendo evidencia satelital, clima, suelo, scouting y operaciones de campo en prioridades diarias, tareas seguras y memoria operativa.",
      betaBadge: "Beta — determinista, con evidencia",
      controlledPreviewBadge: "Gaucho · Vista previa controlada",
      parcelStatus: "Estado de la parcela",
      priorities: "Instrucciones prioritarias",
      quantifiedIrrigation: "Demanda hídrica de referencia del cultivo",
      referenceCropDemand: "Demanda hídrica de referencia del cultivo",
      referenceCropDemandValue: "Evapotranspiración del cultivo {{etc}} mm/día durante {{days}} días. Uso de agua modelado, no una cantidad a aplicar.",
      applicationTargetUnavailable: "No hay una cantidad de riego a aplicar disponible. Revísalo con tu asesor agronómico antes de regar.",
      blockedDecisions: "Decisiones bloqueadas",
      evidenceUsed: "Evidencia utilizada",
      evidenceMissing: "Evidencia faltante",
      requiredQuestions: "Preguntas requeridas",
      structuredAnswers: "Solo respuestas estructuradas",
      questionsAnswered: "Todas las preguntas requeridas han sido respondidas para esta ventana.",
      qIrrigationLabel: "¿Esta parcela recibió riego en la ventana actual?",
      qHarvestLabel: "¿Se ha cosechado el cultivo principal?",
      btnNoIrrigation: "No se aplicó riego",
      btnIrrigationApplied: "Riego aplicado",
      btnNotSure: "No estoy seguro",
      btnStillActive: "Aún activo",
      btnNearHarvest: "Próximo a cosecha",
      btnHarvested: "Cosechado",
      saveSuccessTitle: "Confirmación guardada",
      saveFailedTitle: "No se pudo guardar esta confirmación",
      saveFailedDescription: "Inténtalo de nuevo o contacta con soporte.",
      unsupportedPersistenceDescription: "Esta respuesta no puede guardarse de forma segura con la configuración actual del cuaderno de campo. La decisión permanece bloqueada.",
      statusSaved: "Guardado",
      statusBlocked: "Sigue faltando evidencia",
      statusRequiresSeason: "Requiere configurar campaña",
      msgNoIrrigationNotPersisted: "La confirmación de 'sin riego' aún no se persiste en esta versión. La decisión de riego seguirá bloqueada hasta que se soporte este tipo de confirmación.",
      msgIrrigationUncertain: "El estado del riego sigue siendo incierto. La decisión de riego permanece bloqueada.",
      msgLifecycleUncertain: "El estado del ciclo del cultivo es incierto. Las decisiones que dependen del ciclo permanecen bloqueadas hasta confirmarse.",
      msgRequiresSeason: "No se encontró una campaña activa. Abre Campañas para crear o confirmar la campaña del cultivo primero.",
      msgError: "No se pudo guardar esta confirmación. Inténtalo de nuevo o contacta con soporte.",
      msgNotAuthenticated: "Es necesario iniciar sesión para guardar esta confirmación.",
      fieldDate: "Fecha",
      fieldAmount: "Cantidad (opcional)",
      fieldAmountPlaceholder: "p. ej. 12",
      fieldUnit: "Unidad",
      fieldScope: "Ámbito",
      scopeWholeParcel: "Parcela completa",
      fieldNotes: "Notas (opcional)",
      fieldHarvestDate: "Fecha de cosecha",
      fieldYieldKgHa: "Rendimiento (kg/ha, opcional)",
      fieldNextCrop: "Próximo cultivo planificado (opcional)",
      fieldPostHarvestObjective: "Objetivo post-cosecha",
      objNitrogenFixation: "Fijación de nitrógeno",
      objErosionControl: "Control de erosión",
      objSoilStructure: "Estructura del suelo",
      objWeedSuppression: "Supresión de malezas",
      objBiodiversity: "Biodiversidad",
      objOrganicMatter: "Materia orgánica",
      objMoistureConservation: "Conservación de humedad",
      save: "Guardar",
      nextSteps: "Próximos pasos recomendados",
      doNotConclude: "No concluir",
      days: "días",
      zone: "Zona",
      priorityValues: { low: "Baja", medium: "Media", high: "Alta", critical: "Crítica" },
      showMore: "+ {{count}} más",
      showLess: "Mostrar menos",
      urgency: {
        immediate_review: "Revisión inmediata",
        today: "Hoy",
        next_24h: "Próximas 24 h",
        next_7d: "Próximos 7 días",
        routine: "Rutina",
      },
      suggestedTasks: "Tareas sugeridas",
      rankedPriorities: "Prioridades ordenadas",
      tasksHumanReviewBadge: "Requiere revisión humana",
      tasksNotExecutedAutomatically: "No se ejecuta automáticamente.",
      dailyBriefTitle: "Brief de hoy",
      dailyBriefTopRisks: "Riesgos principales",
      dailyBriefTopPriorities: "Prioridades de hoy",
      dailyBriefSuggestedTasks: "Tareas sugeridas",
      memoryTitle: "Memoria de la parcela",
      memoryEmpty: "Aún no hay evidencia histórica de la parcela disponible.",
      memoryError: "No se puede cargar la evidencia histórica en este momento.",
      memoryStale: "(desactualizado)",
      memoryHistoricalContextBadge: "Contexto histórico",
      memoryRecentConfirmations: "Confirmaciones recientes",
      memoryRecentReports: "Informes recientes",
      memoryRecentFieldActivities: "Actividades de campo recientes",
      memoryRecentIrrigation: "Registros de riego recientes",
      memoryRecentScouting: "Registros de monitoreo recientes",
      memoryRecentSoilFoliar: "Evidencia de suelo / foliar",
      memoryRecentSeasons: "Historial del ciclo del cultivo",
      memoryRecentRisks: "Registros históricos de riesgo",
      memoryStatus: {
        loaded: "Cargado",
        empty: "Vacío",
        error: "Error",
        not_loaded: "No cargado",
      },
      lifecycle: {
        active_crop: "Cultivo activo",
        near_harvest: "Próximo a cosecha",
        harvested_confirmed: "Cosechado",
        post_harvest_window: "Ventana post-cosecha",
        unknown: "Ciclo no confirmado",
      },
      decisions: {
        irrigation_amount_by_zone: "Cantidad de riego por zona",
        irrigation_timing: "Momento de riego",
        irrigation_need: "Necesidad de riego",
        fertilization_recommendation_n: "Recomendación de nitrógeno",
        fertilization_recommendation_pk: "Recomendación de P y K",
        vra_export_readiness: "Disponibilidad de exportación VRA",
        report_generation_requirement: "Generación de informe",
        compliance_evidence_check: "Verificación de evidencia de cumplimiento",
        lifecycle_planning_questions: "Planificación del ciclo",
        frost_protection_prep: "Protección contra heladas",
        drought_outlook: "Perspectiva de sequía",
        scouting_priority_by_zone: "Prioridad de scouting por zona",
      },
      reasons: {
        quantified_irrigation_gate_not_satisfied: "No se cumplen los requisitos para riego cuantificado.",
        sar_contradiction_with_field_evidence: "La señal SAR contradice la evidencia de campo.",
        forecast_7d_missing: "Falta la previsión a 7 días.",
        no_persisted_soil_or_foliar_evidence: "Sin análisis de suelo o foliar persistido.",
        low_vigor_zone_requires_field_validation_before_irrigation:
          "La zona de bajo vigor requiere validación de campo antes del riego.",
      },
      evidence: {
        parcel_id: "Identidad de la parcela",
        crop_type: "Tipo de cultivo",
        area_ha: "Superficie (ha)",
        ndvi_trend: "Tendencia NDVI",
        ndre_trend: "Tendencia NDRE",
        vigor_zones: "Zonas de vigor",
        zone_area: "Superficie de la zona",
        vegetation_anomaly: "Anomalía vegetativa",
        satellite_recency: "Recencia de satélite",
        phenological_stage: "Fase fenológica",
        foliar_analysis: "Análisis foliar",
        weather_current: "Clima actual",
        forecast_7d: "Previsión a 7 días",
        et0: "ET0",
        etc: "ETc",
        kc_dual: "FAO-56 Kc dual",
        irrigation_log: "Registro de riego aplicado",
        no_irrigation_confirmation: "Confirmación de no riego",
        sar_soil_moisture: "Humedad de suelo SAR",
        active_alerts: "Alertas activas",
        drought_risk: "Riesgo de sequía",
        pest_disease_risk: "Riesgo de plagas y enfermedades",
        frost_risk: "Riesgo de heladas",
        fire_risk: "Riesgo de incendio",
        agronomic_risk_ml: "Riesgo agronómico ML",
        economic_risk: "Riesgo económico",
        nitrogen_recommendation: "Recomendación de nitrógeno",
        pk_recommendation: "Recomendación de P y K",
        vra_zones: "Zonas VRA",
        irrigation_report: "Informe de riego",
        soil_lab_analysis: "Análisis de suelo / laboratorio",
        evidence_report: "Informe de evidencia",
        compliance_pac_readiness: "Disponibilidad PAC / cumplimiento",
        parcel_passport: "Registro digital de la parcela",
        audit_trail: "Trazabilidad",
        harvest_status: "Estado de la cosecha",
        next_crop: "Próximo cultivo previsto",
        post_harvest_objective: "Objetivo post-cosecha",
        farm_context: "Contexto de la explotación",
        season_state: "Estado de la campaña",
        planting_event: "Evento de siembra",
        harvest_event: "Evento de cosecha",
        planned_operations: "Operaciones planificadas",
        field_events: "Eventos de campo",
        harvested_confirmed: "Cosecha confirmada",
        near_harvest_confirmed: "Próximo a cosecha confirmado",
        crop_active_confirmed: "Cultivo activo confirmado",
        next_crop_declared: "Próximo cultivo declarado",
        post_harvest_objective_declared: "Objetivo post-cosecha declarado",
        current_crop_known: "Cultivo actual conocido",
        previous_crop_known: "Cultivo anterior conocido",
        soil_analysis_present: "Análisis de suelo disponible",
        foliar_analysis_present: "Análisis foliar disponible",
        field_validation_or_scouting_present: "Validación de campo o monitoreo disponible",
        planting_window_known: "Ventana de siembra conocida",
        water_availability_known: "Disponibilidad de agua conocida",
        location_context_known: "Contexto de ubicación conocido",
      },
      evidenceSummary: {
        recent_phenology_evidence_near_harvest_or_post_harvest_stage:
          "Observaciones fenológicas recientes indican fase próxima o posterior a cosecha.",
        recent_phenology_evidence_available: "Observaciones fenológicas recientes disponibles.",
        recent_foliar_evidence_indicates_poor_or_fair_overall_health:
          "El análisis foliar reciente indica salud general pobre o regular.",
        recent_foliar_evidence_available: "Análisis foliar reciente disponible.",
        recent_soil_analysis_indicates_ph_or_organic_matter_concern:
          "El análisis de suelo reciente indica preocupación por pH o materia orgánica.",
        recent_soil_analysis_available: "Análisis de suelo reciente disponible.",
        recent_vegetation_indices_available: "Índices de vegetación recientes disponibles.",
        recent_drought_water_stress_evidence_available:
          "Evidencia reciente de sequía / estrés hídrico disponible.",
        soil_analysis_present: "Análisis de suelo disponible.",
        foliar_analysis_present: "Análisis foliar disponible.",
        field_validation_or_scouting_present: "Validación o scouting de campo disponible.",
        pest_disease_scouting_completeness_sufficient_for_review:
          "Completitud del scouting de plagas y enfermedades: suficiente para revisión agronómica.",
        pest_disease_scouting_completeness_partial:
          "Completitud del scouting de plagas y enfermedades: parcial.",
        pest_disease_scouting_completeness_incomplete:
          "Completitud del scouting de plagas y enfermedades: incompleta.",
        pest_disease_scouting_completeness_no_recent_scouting:
          "Completitud del scouting de plagas y enfermedades: sin scouting reciente.",
        pest_disease_scouting_completeness_not_applicable:
          "Completitud del scouting de plagas y enfermedades: no aplicable.",
      },
      evidenceGroups: {
        identity: "Identidad",
        satellite: "Satélite y vegetación",
        water: "Agua y riego",
        lab: "Evidencia de laboratorio",
        planning: "Planificación del cultivo",
        risk: "Riesgo",
        other: "Otros",
      },
      safetyCategories: {
        field_operations: "Operaciones de campo",
        inputs_prescriptions: "Insumos y prescripciones",
        diagnosis: "Diagnóstico y causalidad",
        evidence_limits: "Límites de la evidencia",
        legal_insurance: "Legal, seguro y cumplimiento",
      },
      safetyCategoryDefault: {
        field_operations:
          "No ejecuta riego, fertirriego, pulverización, fertilización ni operaciones de maquinaria.",
        inputs_prescriptions:
          "No recomienda productos, dosis, mezclas, principios activos ni momento de aplicación.",
        diagnosis:
          "No confirma plaga, enfermedad, deficiencia nutricional, toxicidad, estrés hídrico ni pérdida de rendimiento sin validación cualificada.",
        evidence_limits:
          "No reemplaza la validación en campo, la interpretación de laboratorio ni la revisión agronómica.",
        legal_insurance:
          "No concluye validez de seguro, cumplimiento, responsabilidad legal ni instrucciones de emergencia.",
      },
      showSafetyDetails: "Mostrar detalles técnicos de seguridad",
      hideSafetyDetails: "Ocultar detalles técnicos de seguridad",
      questions: {
        confirm_harvest_status: "¿Se ha cosechado el cultivo principal?",
        declare_next_crop: "¿Cuál es el próximo cultivo previsto?",
        declare_post_harvest_objective: "¿Cuál es tu principal objetivo post-cosecha?",
        confirm_no_irrigation: "Confirma si la parcela no ha recibido riego en la ventana.",
        confirm_field_scouting_done: "Confirma si se ha realizado el scouting en campo.",
      },
      instructions: {
        refresh_forecast_before_irrigation_amount_and_timing:
          "Actualiza la previsión a 7 días antes de calcular cantidad o momento de riego.",
        upload_or_import_soil_lab_analysis:
          "Sube o importa un análisis de suelo / laboratorio reciente.",
        prioritize_field_scouting_for_active_alerts:
          "Prioriza el scouting de campo para las alertas activas de plagas o enfermedades.",
        low_vigor_zone_requires_field_scouting_before_irrigation:
          "Las zonas de bajo vigor requieren scouting en campo antes del riego.",
        review_current_water_state_for_zone:
          "Revisa la evidencia actual del estado hídrico de esta zona. El vigor no determina una cantidad de riego a aplicar.",
        generate_evidence_report_if_decisions_are_shared:
          "Genera un informe de evidencia si vas a compartir las decisiones con terceros.",
        review_foliar_analysis_with_agronomist:
          "Revisa el análisis foliar con un agrónomo cualificado.",
        review_soil_analysis_with_agronomist:
          "Revisa el análisis de suelo con un agrónomo cualificado.",
        compare_soil_with_foliar_phenology_and_rotation:
          "Compara el análisis de suelo con el foliar, la fenología y la rotación.",
        validate_crop_stage_against_lifecycle:
          "Valida la etapa del cultivo contra el ciclo antes de programar operaciones.",
        review_crop_stage_context_near_harvest:
          "Revisa el contexto de la etapa del cultivo — parcela próxima a cosecha.",
        validate_satellite_hotspot_with_official_sources_and_field_check:
          "Valida el foco satelital con fuentes oficiales de emergencia y revisión en campo.",
        validate_vegetation_anomaly_in_field:
          "Valida la anomalía de vegetación en campo antes de concluir.",
        validate_water_stress_in_field_and_review_fao56_and_irrigation_log:
          "Valida el estrés hídrico en campo y revisa el cálculo FAO-56 y el registro de riego.",
        review_foliar_analysis_and_nutrient_balance_with_qualified_agronomist:
          "Revisa el análisis foliar y el balance nutricional con un agrónomo cualificado.",
        review_soil_analysis_and_compare_with_foliar_phenology_and_rotation:
          "Revisa el análisis de suelo y compáralo con foliar, fenología y rotación.",
        refresh_foliar_analysis_via_existing_foliar_analysis_module:
          "Actualiza el análisis foliar desde el módulo de Análisis Foliar.",
        complete_pest_disease_scouting_details_and_validate_symptoms_in_field:
          "Completa el scouting de plagas y enfermedades y valida los síntomas en campo.",
        pest_disease_scouting_missing_observation_date:
          "Falta la fecha de observación.",
        pest_disease_scouting_missing_observation_type:
          "Falta el tipo de observación de plaga o enfermedad.",
        pest_disease_scouting_missing_severity_class:
          "Falta la clase de severidad.",
        pest_disease_scouting_missing_symptom_description:
          "Falta la descripción de los síntomas.",
        pest_disease_scouting_missing_affected_organ:
          "Falta el órgano vegetal afectado.",
        pest_disease_scouting_missing_incidence_estimate:
          "Falta la incidencia estimada (porcentaje aproximado de plantas afectadas).",
        pest_disease_scouting_missing_spatial_distribution:
          "Falta la distribución espacial (localizada, dispersa o generalizada).",
        pest_disease_scouting_missing_photo_evidence:
          "Falta evidencia fotográfica.",
        pest_disease_scouting_missing_phenological_stage:
          "Falta la fase fenológica (contexto BBCH).",
        pest_disease_scouting_missing_recent_weather_context:
          "Falta el contexto meteorológico reciente.",
        pest_disease_scouting_missing_treatment_history:
          "Falta el historial reciente de tratamientos.",
        pest_disease_scouting_missing_agronomist_ipm_review:
          "Falta la revisión del agrónomo o asesor de MIP.",
      },
      doNotConcludeItems: {
        herbicide_prescription: "Prescripción de herbicida",
        fungicide_prescription: "Prescripción de fungicida",
        pesticide_prescription: "Prescripción de pesticida",
        treatment_product: "Producto de tratamiento",
        treatment_dose: "Dosis de tratamiento",
        treatment_timing: "Momento del tratamiento",
        guaranteed_diagnosis: "Diagnóstico garantizado",
        cover_crop_species: "Especie de cubierta vegetal",
        cover_crop_mix: "Mezcla de cubierta vegetal",
        do_not_conclude_active_fire_from_gaucho: "No confirma un incendio activo.",
        do_not_replace_emergency_services_112: "No reemplaza al 112 ni a Protección Civil.",
        do_not_issue_evacuation_instructions: "No emite instrucciones de evacuación.",
        do_not_claim_frost_damage: "No confirma daño por helada.",
        do_not_activate_machinery_or_protection_systems_automatically:
          "No activa maquinaria, calefactores, máquinas de viento, riego ni sistemas de protección automáticamente.",
        do_not_activate_machinery_heaters_wind_machines_or_irrigation_as_frost_protection_automatically:
          "No activa maquinaria, calefactores, máquinas de viento ni riego como protección antihelada automáticamente.",
        do_not_treat_forecast_as_certainty: "El pronóstico no es certeza.",
        do_not_confirm_diagnosis_from_gaucho: "No confirma diagnóstico de plaga ni enfermedad.",
        do_not_recommend_treatment_product_dose_or_application:
          "No recomienda producto, principio activo, dosis ni aplicación.",
        do_not_instruct_spraying_application_treatment_or_execution:
          "No indica pulverización, aplicación, tratamiento ni ejecución.",
        do_not_recommend_pesticide_fungicide_herbicide_biological_control_active_ingredient_or_dose:
          "No recomienda pesticida, fungicida, herbicida, control biológico, principio activo ni dosis.",
        do_not_schedule_or_execute_irrigation_from_this_item:
          "No programa ni ejecuta riego a partir de este ítem.",
        do_not_schedule_or_execute_irrigation_from_this_task:
          "No programa ni ejecuta riego a partir de esta tarea.",
        do_not_relax_fao56_gates: "Los gates FAO-56 nunca se relajan.",
        do_not_quantify_irrigation_from_log_evidence_alone:
          "No cuantifica riego solo a partir del registro.",
        do_not_create_irrigation_execution_pump_valve_machinery_or_fertigation_action_from_log_alone:
          "No ejecuta acciones de riego, bomba, válvula, maquinaria ni fertirriego solo a partir del registro.",
        do_not_infer_applied_irrigation_from_fao56_demand_ndvi_sar_weather_or_water_stress_alone:
          "No infiere riego aplicado solo a partir de demanda FAO-56, NDVI, SAR, clima ni señales de estrés hídrico.",
        do_not_infer_cause_from_ndvi_alone: "No infiere causa solo del NDVI.",
        do_not_infer_compliance_insurance_or_liability:
          "No infiere cumplimiento, seguro ni responsabilidad.",
        do_not_replace_field_validation: "No reemplaza la validación en campo.",
        do_not_replace_qualified_agronomic_judgment:
          "No reemplaza el criterio agronómico calificado.",
        do_not_recommend_fertilizer_product_or_dose:
          "No recomienda producto fertilizante ni dosis.",
        do_not_recommend_sowing_or_planting_execution:
          "No recomienda ejecución de siembra ni plantación.",
        do_not_recommend_cover_crop_species_or_mix:
          "No recomienda especies ni mezclas específicas de cultivos de cobertura.",
        do_not_execute_actions_automatically: "No ejecuta acciones automáticamente.",
        do_not_conclude_reports_imply_compliance:
          "Los informes históricos no implican cumplimiento.",
        do_not_conclude_reports_imply_insurance_validity:
          "Los informes históricos no implican validez de seguro.",
        do_not_conclude_historical_is_current_diagnosis:
          "La evidencia histórica no confirma el diagnóstico actual.",
        do_not_conclude_historical_replaces_field_validation:
          "La evidencia histórica no reemplaza la validación en campo.",
        do_not_conclude_historical_frost_fire_prove_current_emergency:
          "Los registros históricos de helada/incendio no prueban una emergencia actual.",
        do_not_conclude_historical_irrigation_proves_current_water_status:
          "El riego histórico no prueba el estado hídrico actual.",
        do_not_conclude_historical_ndvi_infers_current_cause:
          "El NDVI histórico no infiere causa actual.",
        do_not_conclude_historical_scouting_confirms_current_pest_disease:
          "El monitoreo histórico no confirma plaga ni enfermedad actual.",
        do_not_conclude_historical_soil_foliar_implies_product_or_dose:
          "La evidencia histórica de suelo/foliar no implica ningún producto ni dosis.",
        do_not_conclude_stale_confirmations_override_current_evidence:
          "Las confirmaciones desactualizadas no sustituyen la evidencia actual.",
        soil_do_not_recommend_fertilizer_product_or_dose_alone:
          "La evidencia de suelo por sí sola no recomienda producto ni dosis de fertilizante.",
        soil_do_not_recommend_amendment_or_blend_alone:
          "La evidencia de suelo por sí sola no recomienda enmienda ni mezcla.",
        soil_do_not_execute_fertilization:
          "La evidencia de suelo no ejecuta fertilización.",
        soil_do_not_execute_fertigation:
          "La evidencia de suelo no ejecuta fertirriego.",
        soil_do_not_infer_nutrient_deficiency_alone:
          "La evidencia de suelo por sí sola no confirma deficiencia nutricional.",
        soil_do_not_infer_toxicity_alone:
          "La evidencia de suelo por sí sola no confirma toxicidad.",
        soil_do_not_infer_irrigation_need_alone:
          "La evidencia de suelo por sí sola no infiere necesidad de riego.",
        soil_do_not_relax_fao56_gates:
          "La evidencia de suelo no relaja los gates FAO-56.",
        soil_do_not_override_nitrogen_or_pk_optimizer:
          "La evidencia de suelo no anula el optimizador de nitrógeno ni P&K.",
        soil_do_not_infer_yield_loss_insurance_compliance_or_liability:
          "La evidencia de suelo no infiere pérdida de rendimiento, seguro, cumplimiento ni responsabilidad.",
        soil_do_not_replace_agronomist_interpretation:
          "La evidencia de suelo no reemplaza la interpretación agronómica cualificada.",
        foliar_do_not_recommend_fertilizer_product_or_dose_alone:
          "La evidencia foliar por sí sola no recomienda producto ni dosis de fertilizante.",
        foliar_do_not_recommend_amendment_or_blend_alone:
          "La evidencia foliar por sí sola no recomienda enmienda ni mezcla.",
        foliar_do_not_execute_fertilization:
          "La evidencia foliar no ejecuta fertilización.",
        foliar_do_not_execute_fertigation:
          "La evidencia foliar no ejecuta fertirriego.",
        foliar_do_not_infer_pest_or_disease_diagnosis_alone:
          "La evidencia foliar por sí sola no confirma diagnóstico de plaga ni enfermedad.",
        foliar_do_not_infer_water_stress_or_irrigation_need_alone:
          "La evidencia foliar por sí sola no infiere estrés hídrico ni necesidad de riego.",
        foliar_do_not_relax_fao56_gates:
          "La evidencia foliar no relaja los gates FAO-56.",
        foliar_do_not_replace_agronomist_interpretation:
          "La evidencia foliar no reemplaza la interpretación agronómica cualificada.",
        foliar_do_not_infer_yield_loss_insurance_compliance_or_liability:
          "La evidencia foliar no infiere pérdida de rendimiento, seguro, cumplimiento ni responsabilidad.",
        pest_disease_scouting_completeness_does_not_confirm_diagnosis:
          "La completitud del scouting no confirma un diagnóstico de plaga o enfermedad.",
        pest_disease_scouting_completeness_does_not_authorize_treatment:
          "La completitud del scouting no autoriza ningún tratamiento fitosanitario.",
        pest_disease_scouting_completeness_does_not_recommend_product_or_dose:
          "La completitud del scouting no recomienda ningún pesticida, fungicida, herbicida, producto de control biológico, principio activo ni dosis.",
        pest_disease_scouting_completeness_does_not_instruct_spraying_or_application:
          "La completitud del scouting no indica pulverización, aplicación ni tratamiento.",
        pest_disease_scouting_completeness_does_not_replace_field_scouting_or_agronomist:
          "La completitud del scouting no reemplaza el scouting en campo, la confirmación de laboratorio, la orientación local de MIP ni el juicio agronómico cualificado.",
        pest_disease_scouting_completeness_does_not_infer_insurance_damage_or_liability:
          "La completitud del scouting no infiere seguro, daño, pérdida de rendimiento ni responsabilidad.",
        drought_water_stress_do_not_execute_irrigation:
          "La evidencia de sequía / estrés hídrico no ejecuta riego.",
        drought_water_stress_do_not_schedule_irrigation_alone:
          "La evidencia de sequía / estrés hídrico por sí sola no programa riego.",
        drought_water_stress_do_not_quantify_irrigation_alone:
          "La evidencia de sequía / estrés hídrico por sí sola no cuantifica riego.",
        drought_water_stress_do_not_infer_applied_irrigation:
          "La evidencia de sequía / estrés hídrico no infiere riego aplicado.",
        drought_water_stress_do_not_relax_fao56_gates:
          "La evidencia de sequía / estrés hídrico no relaja los gates FAO-56.",
        drought_water_stress_do_not_confirm_crop_or_yield_loss:
          "La evidencia de sequía / estrés hídrico no confirma pérdida de cultivo ni rendimiento.",
        drought_water_stress_do_not_infer_insurance_compliance_or_liability:
          "La evidencia de sequía / estrés hídrico no infiere seguro, cumplimiento ni responsabilidad.",
        vegetation_indices_do_not_infer_cause_alone:
          "Los índices de vegetación por sí solos no infieren causa.",
        vegetation_indices_do_not_recommend_irrigation_alone:
          "Los índices de vegetación por sí solos no recomiendan riego.",
        vegetation_indices_do_not_recommend_fertilizer_product_or_dose_alone:
          "Los índices de vegetación por sí solos no recomiendan producto ni dosis de fertilizante.",
        vegetation_indices_do_not_recommend_pesticide_fungicide_or_herbicide_alone:
          "Los índices de vegetación por sí solos no recomiendan pesticida, fungicida ni herbicida.",
        vegetation_indices_do_not_confirm_pest_disease_or_water_stress:
          "Los índices de vegetación no confirman plaga, enfermedad ni estrés hídrico.",
        vegetation_indices_do_not_relax_fao56_gates:
          "Los índices de vegetación no relajan los gates FAO-56.",
        vegetation_indices_do_not_execute_field_operations:
          "Los índices de vegetación no ejecutan operaciones de campo.",
        phenology_do_not_execute_irrigation:
          "La fenología no ejecuta riego.",
        phenology_do_not_execute_fertilization:
          "La fenología no ejecuta fertilización.",
        phenology_do_not_recommend_fertilizer_product_or_dose_alone:
          "La fenología por sí sola no recomienda producto ni dosis de fertilizante.",
        phenology_do_not_recommend_pesticide_fungicide_or_herbicide_alone:
          "La fenología por sí sola no recomienda pesticida, fungicida ni herbicida.",
        phenology_do_not_infer_disease_pest_or_water_stress_alone:
          "La fenología por sí sola no infiere enfermedad, plaga ni estrés hídrico.",
        phenology_do_not_update_harvest_status_automatically:
          "La fenología no actualiza el estado de cosecha automáticamente.",
        phenology_do_not_execute_sowing_planting_or_harvesting:
          "La fenología no ejecuta siembra, plantación ni cosecha.",
        phenology_do_not_infer_yield_loss_insurance_compliance_or_liability:
          "La fenología no infiere pérdida de rendimiento, seguro, cumplimiento ni responsabilidad.",
      },
      cropRotation: {
        title: "Asesor de rotación de cultivos",
        badge: "Asesoría",
        disclaimer:
          "Esta es una ayuda de planificación consultiva, no una instrucción de siembra. Validá localmente con un agrónomo.",
        humanReview: "Requiere revisión humana",
        confidence: "Confianza: {{level}}",
        confidenceLevel: { low: "baja", moderate: "moderada" },
        readyForReview: "Listo para revisión agronómica",
        blocked: {
          title: "Asesor de rotación bloqueado",
          missingInputs: "Faltan entradas obligatorias de planificación.",
          noRecommendation: "No se generó ninguna recomendación de cultivo.",
          missingLabel: "Entradas de planificación faltantes",
        },
        planning: {
          availableEvidence: "Evidencia disponible",
          missing: "Faltantes",
          status: {
            ready_for_planning: "Contexto de planificación listo",
            missing_required_inputs: "Faltan entradas de planificación obligatorias",
            blocked: "Contexto de planificación bloqueado",
          },
        },
        requiredValidation: "Validación requerida",
        risksUnknowns: "Riesgos / incógnitas",
        categories: {
          legume_cover_crop_options: "Opciones de cultivos de cobertura leguminosos",
          cereal_cover_crop_options: "Opciones de cultivos de cobertura cereales",
          mixed_cover_crop_options: "Opciones de cultivos de cobertura mixtos",
          soil_restoration_options: "Opciones de restauración de suelo",
          erosion_control_options: "Opciones de control de erosión",
          fallow_or_rest_period_review: "Revisión de barbecho / período de descanso",
        },
        missingInputs: {
          harvest_status: "Estado de la cosecha",
          current_or_previous_crop: "Cultivo actual o anterior",
          next_crop_intention: "Próximo cultivo previsto",
          post_harvest_objective: "Objetivo post-cosecha",
          soil_evidence: "Evidencia de suelo",
          planting_window: "Ventana de siembra",
          water_availability: "Disponibilidad de agua",
        },
        evidenceLabels: {
          harvested_confirmed: "Cosecha confirmada",
          near_harvest_confirmed: "Próximo a cosecha confirmado",
          crop_active_confirmed: "Cultivo activo confirmado",
          next_crop_declared: "Próximo cultivo declarado",
          post_harvest_objective_declared: "Objetivo post-cosecha declarado",
          current_crop_known: "Cultivo actual conocido",
          previous_crop_known: "Cultivo previo conocido",
          soil_analysis_present: "Análisis de suelo disponible",
          foliar_analysis_present: "Análisis foliar disponible",
          field_validation_or_scouting_present: "Validación de campo o monitoreo disponible",
          planting_window_known: "Ventana de siembra conocida",
          water_availability_known: "Disponibilidad de agua conocida",
          location_context_known: "Contexto de ubicación conocido",
        },
        declaredLabels: {
          harvest_status: "Estado de cosecha declarado por el productor",
          next_crop: "Próximo cultivo declarado por el productor",
          post_harvest_objective: "Objetivo post-cosecha declarado por el productor",
        },
        capture: {
          title: "Responder entrada faltante",
          harvestTitle: "Marcar estado de cosecha",
          harvestChoices: {
            active: "Aún activo",
            near_harvest: "Próximo a cosecha",
            harvested: "Cosechado",
            uncertain: "No estoy seguro",
          },
          nextCropTitle: "Declarar próximo cultivo",
          nextCropPlaceholder: "p. ej. cebada",
          objectiveTitle: "Declarar objetivo post-cosecha",
          objectivePlaceholder: "Seleccioná un objetivo",
          objectiveChoices: {
            nitrogen_fixation: "Fijación de nitrógeno",
            erosion_control: "Control de erosión",
            soil_restoration: "Restauración de suelo",
            weed_suppression: "Supresión de malezas",
            not_sure: "No estoy seguro",
          },
          fieldEvidenceTitle: "Evidencia de campo",
          markFieldValidation: "Marcar validación de campo completada",
          markScouting: "Marcar monitoreo completado",
          saveAnswer: "Guardar respuesta",
          answerSaved: "Respuesta guardada",
          couldNotSave: "No se pudo guardar la respuesta",
        },
      },
      missingEvidenceAccess: {
        title: "Actualizar evidencia",
        subtitle: "Abrí el módulo correspondiente para completar la evidencia faltante. No se ejecuta nada automáticamente.",
        openLabel: "Abrir",
        answerRequiredQuestions: "Responder preguntas requeridas",
        noAccessAvailable: "Completar desde el módulo correspondiente",
        targets: {
          satellite_monitoring: "Monitorización satélite",
          weather_and_conditions: "Clima y condiciones",
          irrigation_optimizer: "Optimizador de riego",
          field_notebook: "Cuaderno de campo",
          fire_risk: "Riesgo de incendio",
          phenology: "Fenología",
          crop_cycle_planning: "Ciclo del cultivo / planificación",
          drought_water_stress: "Sequía y estrés hídrico",
          foliar_analysis: "Análisis foliar",
        },
      },
      helpCenter: {
        gaucho: "Gaucho",
        aiAgronomist: "Agrónomo IA",
        launcherFarmer: "Abrir Gaucho — cabina de operaciones agrícolas",
        launcherPublic: "Pregunta al Agrónomo IA",
        helpCenter: "Centro de ayuda",
        gauchoSubtitle: "Asistente supervisado de operaciones agrícolas basado en evidencia",
        agronomistSubtitle: "Recomendaciones científicas potenciadas por IA",
        quickAnswers: "Respuestas rápidas y preguntas frecuentes",
        helpAndFaqs: "Ayuda y preguntas frecuentes",
      },
      canonicalNetTarget: {
        sectionTitle: "Objetivo NETO de riego canónico",
        reviewBadge: "Requiere revisión humana",
        supervisedTargetTitle: "Objetivo NETO de riego supervisado",
        basisExplanation:
          "Objetivo NETO en zona radicular derivado del estado hídrico modelado canónico y de la política de manejo revisada. No es una lámina bruta aplicada.",
        noTargetProposed: "No se propone ningún objetivo NETO de riego.",
        notTriggeredExplanation:
          "Umbral de manejo no alcanzado. No se propone ningún objetivo NETO de riego.",
        statusLabel: {
          available: "Disponible para revisión supervisada",
          not_triggered: "No activado",
          blocked: "No disponible",
          unavailable: "No disponible",
          system_error: "No disponible",
          not_loaded: "No cargado",
        },
        blockerReason: {
          generic: "Aún no se cumplen los requisitos de evidencia canónica.",
          system_error: "No se pudo leer el estado hídrico canónico.",
          missing_canonical_water_state:
            "No existe estado hídrico modelado canónico para esta parcela y día.",
          rejected_legacy_water_state:
            "El estado hídrico almacenado no cumple los requisitos de lectura canónica.",
          invalid_decision_day: "El día de decisión no es válido.",
          no_active_crop_season: "No hay campaña de cultivo activa declarada.",
          ambiguous_active_crop_season:
            "Hay más de una campaña de cultivo activa declarada.",
          missing_reviewed_policy: "No existe una política de manejo revisada.",
          ambiguous_active_policy: "Hay más de una política de manejo activa.",
          invalid_policy_record: "La política de manejo revisada no es válida.",
          policy_not_yet_valid: "La política de manejo revisada aún no está vigente.",
          policy_expired: "La política de manejo revisada ha expirado.",
          exact_water_state_cutoff_unavailable:
            "Aún no se dispone del corte exacto de evidencia del estado hídrico. Gaucho no cuantificará un objetivo de riego actual hasta que la lluvia y el riego posteriores puedan ordenarse con seguridad respecto al estado hídrico canónico.",
          temporal_resolution_insufficient:
            "Los eventos de lluvia y riego no pueden ordenarse respecto al estado hídrico con la resolución temporal disponible.",
          post_state_water_event_requires_recompute:
            "Hubo lluvia o riego posterior al estado hídrico modelado; primero debe recalcularse el balance.",
          post_state_water_event_evidence_incomplete:
            "La evidencia de lluvia y/o riego posterior al estado hídrico modelado está incompleta.",
          stale_water_state:
            "El estado hídrico modelado no está vigente para el día de decisión.",
          missing_post_state_water_event_evidence:
            "Falta la evidencia de lluvia y riego posterior al estado hídrico modelado.",
          missing_root_zone_depletion:
            "El agotamiento de la zona radicular (Dr) no está disponible en el estado hídrico canónico.",
          invalid_root_zone_depletion:
            "El agotamiento de la zona radicular (Dr) del estado hídrico canónico no es válido.",
          management_threshold_unavailable:
            "El umbral de agua fácilmente disponible (RAW) no está disponible.",
          management_threshold_not_reached:
            "El agotamiento de la zona radicular no ha alcanzado el umbral de manejo revisado.",
          missing_taw_for_target_policy_validation:
            "Se requiere el agua total disponible (TAW) para validar la política de objetivo y no está disponible.",
          invalid_taw_for_target_policy_validation:
            "El agua total disponible (TAW) no es válida para validar la política de objetivo.",
          missing_target_policy:
            "No hay ninguna política de objetivo revisada disponible.",
          invalid_target_policy: "La política de objetivo revisada no es válida.",
        },
        limitations: {
          net_root_zone_target_not_gross_applied_depth:
            "Objetivo NETO en zona radicular — no es lámina bruta aplicada.",
          no_irrigation_duration: "No es una duración de riego.",
          no_irrigation_schedule: "No es una programación de riego.",
          no_execution_command: "No es una orden de ejecución.",
          human_agronomic_review_required: "Se requiere revisión agronómica humana.",
        },
      },
      waterStressSemantics: {
        sectionTitle: "Lectura hídrica de Gaucho",
        disclaimer:
          "Interpretación solo lectura — no ejecuta ni autoriza riego.",
        statusLabel: {
          not_applicable_until_cycle_confirmed: "No aplicable",
          insufficient_evidence: "Evidencia insuficiente",
          stale: "Desactualizado",
          blocked: "Bloqueado",
          low: "Bajo",
          elevated: "Elevado",
          high: "Alto",
        },
        categoryTitle: {
          satellite_water_stress: "Satélite: estrés hídrico observado",
          atmospheric_demand: "Clima: demanda atmosférica",
          drought_risk_context: "Sequía: contexto de riesgo",
          fao56_irrigation_requirement: "FAO-56: requerimiento de riego",
        },
        satellite_water_stress_insufficient_evidence:
          "Evidencia satelital insuficiente para clasificar estrés hídrico.",
        satellite_water_stress_stale:
          "Señal satelital desactualizada — refrescar evidencia antes de decidir.",
        satellite_water_stress_not_applicable_until_cycle_confirmed:
          "Estrés hídrico no aplicable hasta confirmar ciclo/cultivo activo.",
        satellite_water_stress_low_recent_signal:
          "Señal satelital de estrés hídrico baja — no equivale a ausencia de estrés.",
        satellite_water_stress_elevated_validate_in_field:
          "Señal satelital de estrés hídrico elevada — validar en campo.",
        satellite_vegetation_anomaly_validate_in_field:
          "Anomalía en índices de vegetación — validar causa en campo.",
        atmospheric_demand_insufficient_evidence:
          "Evidencia meteorológica insuficiente para clasificar la demanda atmosférica.",
        atmospheric_demand_forecast_missing:
          "Falta previsión meteorológica de 7 días — no se puede clasificar la demanda atmosférica.",
        atmospheric_demand_low_from_et0:
          "Demanda atmosférica baja según ET0 — mantener seguimiento.",
        atmospheric_demand_elevated_from_et0:
          "Demanda atmosférica elevada por ET0/temperatura — revisar evolución y previsión.",
        atmospheric_demand_very_high_from_et0:
          "Demanda atmosférica muy elevada por ET0 — revisar previsión y validar en campo; no equivale a orden de riego.",
        drought_risk_context_insufficient_evidence:
          "Contexto de sequía no disponible — evidencia insuficiente.",
        drought_risk_context_stale:
          "Contexto de sequía desactualizado — refrescar antes de decidir.",
        drought_risk_context_low:
          "Contexto de sequía sin riesgo activo — mantener seguimiento.",
        drought_risk_context_active_not_irrigation_instruction:
          "Contexto de riesgo de sequía/estrés hídrico — no equivale a una orden de riego.",
        fao56_irrigation_requirement_blocked:
          "Cálculo FAO-56 no disponible todavía — falta evidencia para revisar la cantidad de riego.",
        fao56_irrigation_requirement_blocked_missing_evidence:
          "Cálculo FAO-56 no disponible — faltan ET0 o ETc para revisar la cantidad de riego.",
        fao56_irrigation_requirement_blocked_forecast_missing:
          "Cálculo cuantificado disponible para revisión. La recomendación de riego por zonas permanece bloqueada hasta disponer de la previsión meteorológica de 7 días. Sin ejecución automática.",
        fao56_irrigation_requirement_blocked_cycle_not_confirmed:
          "Cálculo cuantificado disponible para revisión. La recomendación de riego por zonas permanece bloqueada hasta confirmar el ciclo del cultivo. Sin ejecución automática.",
        fao56_irrigation_requirement_blocked_gates_pending:
          "Cálculo cuantificado disponible para revisión. La recomendación de riego por zonas permanece bloqueada hasta confirmar el ciclo y validar las zonas de bajo vigor.",
        fao56_irrigation_requirement_not_applicable_until_cycle_confirmed:
          "Requerimiento FAO-56 no aplicable hasta confirmar ciclo/cultivo activo.",
        fao56_irrigation_requirement_available_for_review:
          "FAO-56 disponible para revisar cantidad de riego — no ejecuta riego automáticamente.",
        combined: {
          satellite_low_but_atmospheric_elevated:
            "Estrés satelital bajo, pero demanda atmosférica elevada.",
          harvested_or_out_of_cycle_no_stress_not_applicable:
            "No aplicable hasta confirmar ciclo/cultivo activo.",
          missing_evidence_generic:
            "Evidencia insuficiente para clasificar estrés hídrico.",
          stale_signal_generic:
            "Señal desactualizada — refrescar evidencia antes de decidir.",
        },
        humanReview: {
          field_validation_required: "Requiere validación en campo",
          producer_confirmation_required: "Requiere confirmación del productor",
          blocked_by_missing_evidence: "Bloqueado por evidencia faltante",
          not_applicable_until_cycle_confirmed:
            "No aplicable hasta confirmar ciclo",
        },
      },
      moduleEvidenceAlignment: {
        sectionTitle: "Alineación de evidencia por módulo",
        sectionSubtitle:
          "Cómo Gaucho está tratando actualmente la evidencia de cada módulo. Solo lectura — no ejecuta ni autoriza operaciones de campo.",
        modules: {
          vegetation_indices: "Índices de vegetación avanzados",
          ndvi_zones: "Zonas NDVI / vigor",
          weather_conditions: "Clima y condiciones",
          phenology: "Inteligencia fenológica",
          gdd: "GDD (herramienta auxiliar)",
          crop_rotation_tools: "Rotación de cultivos (herramientas agrícolas)",
          crop_rotation_gaucho: "Rotación de cultivos (Asesor Gaucho)",
          drought_water_stress: "Contexto de sequía / estrés hídrico",
          fao56_irrigation: "Requerimiento de riego FAO-56",
        },
        status: {
          primary: "Evidencia primaria",
          auxiliary: "Evidencia auxiliar",
          preliminary: "Preliminar (exploratoria)",
          missing: "Faltante",
          stale: "Desactualizada",
          blocked: "Bloqueada",
          not_integrated: "No integrado",
          not_applicable: "No aplicable",
        },
        messages: {
          vegetation_indices_available:
            "Índices de vegetación disponibles como evidencia. La causa requiere validación en campo.",
          vegetation_indices_critical_signal:
            "Señal crítica de vegetación/vigor detectada — validar la causa en el campo.",
          vegetation_indices_missing:
            "No hay evidencia útil de índices de vegetación para esta parcela.",
          vegetation_indices_not_integrated:
            "Los índices de vegetación no se están mostrando actualmente a Gaucho para esta parcela.",
          ndvi_zones_available:
            "Zonas NDVI/vigor disponibles — tratar como variabilidad espacial de vigor.",
          ndvi_zones_missing: "Las zonas NDVI/vigor no están disponibles.",
          ndvi_zones_not_integrated:
            "Las zonas NDVI/vigor no se muestran actualmente a Gaucho.",
          weather_conditions_available:
            "Señales meteorológicas disponibles (condiciones actuales y/o pronóstico).",
          weather_conditions_missing:
            "No hay señales meteorológicas disponibles para esta parcela.",
          weather_risk_inconclusive_forecast_missing:
            "Riesgo no calculado — falta el pronóstico a 7 días.",
          weather_risk_inconclusive_et0_missing:
            "Riesgo no calculado — falta ET0.",
          phenology_confirmed:
            "Etapa fenológica confirmada por el módulo de fenología.",
          phenology_not_configured_for_crop:
            "Fenología no configurada para este cultivo — etapa no confirmada.",
          gdd_auxiliary_tool:
            "GDD está disponible como herramienta agrícola auxiliar. Gaucho no lo usa todavía para desbloquear fenología, riego FAO-56, rotación ni recomendaciones.",
          crop_rotation_tools_preliminary:
            "Recomendaciones preliminares basadas en reglas. Gaucho requiere objetivo post-cosecha, ventana de siembra, disponibilidad de agua y evidencia de suelo para validar una recomendación.",
          crop_rotation_gaucho_available:
            "Asesor de rotación de Gaucho disponible para revisión humana.",
          crop_rotation_gaucho_blocked_missing_inputs:
            "Asesor de rotación de Gaucho bloqueado — faltan entradas de planificación requeridas.",
          crop_rotation_gaucho_planning_missing:
            "El contexto de planificación de rotación no está disponible para esta parcela.",
          drought_context_active:
            "Contexto activo de sequía / estrés hídrico — solo contextual, no es instrucción de riego.",
          drought_context_available:
            "Contexto de sequía / estrés hídrico disponible, sin riesgo activo.",
          drought_context_missing:
            "El contexto de sequía / estrés hídrico no está disponible.",
          drought_context_not_integrated:
            "El contexto de sequía / estrés hídrico no se muestra actualmente a Gaucho.",
          fao56_available_for_review:
            "Cálculo FAO-56 disponible para revisión humana. No ejecuta riego.",
          fao56_blocked_missing_evidence:
            "FAO-56 bloqueado — falta ET0, ETc, pronóstico o evidencia de Kc dual.",
          fao56_blocked_gates_pending:
            "FAO-56 pendiente — otra evidencia requerida no está completa.",
        },
        notes: {
          read_only_alignment:
            "Vista de alineación de solo lectura — sin escrituras ni relajación de compuertas.",
          does_not_execute_field_operations:
            "No ejecuta riego, fertirriego, pulverización ni operaciones de maquinaria.",
          does_not_recommend_product_dose_or_active_ingredient:
            "No recomienda productos, dosis, mezclas ni ingredientes activos.",
          does_not_relax_fao56_gates: "No relaja las compuertas FAO-56.",
          requires_field_validation: "Requiere validación en campo.",
          vegetation_indices_do_not_diagnose_cause:
            "Los índices de vegetación por sí solos no confirman causa, enfermedad, déficit nutricional o necesidad de riego.",
          vegetation_indices_do_not_authorize_irrigation:
            "Los índices de vegetación por sí solos no autorizan riego.",
          ndvi_zones_are_spatial_variability_not_confirmed_water_stress:
            "Las zonas NDVI representan variabilidad espacial, no estrés hídrico confirmado.",
          weather_risk_do_not_mislabel_vegetation_signal_as_weather:
            "Un factor de NDVI bajo es evidencia de vegetación, no necesariamente riesgo meteorológico.",
          phenology_do_not_infer_from_gdd_alone:
            "No inferir fenología solo a partir de GDD.",
          gdd_does_not_confirm_phenology: "GDD no confirma fenología.",
          gdd_does_not_unblock_irrigation_gate:
            "GDD no desbloquea la compuerta FAO-56 / riego.",
          gdd_does_not_unblock_pest_disease_windows:
            "GDD no desbloquea ventanas de plagas/enfermedades.",
          gdd_does_not_unblock_crop_rotation:
            "GDD no desbloquea recomendaciones de rotación.",
          gdd_does_not_update_harvest_status:
            "GDD no actualiza el estado de cosecha.",
          drought_context_is_not_an_irrigation_instruction:
            "El contexto de sequía / estrés hídrico no es una instrucción de riego.",
          fao56_does_not_execute_irrigation: "FAO-56 no ejecuta riego.",
          crop_rotation_tools_not_final_recommendation:
            "La rotación de herramientas agrícolas es preliminar y no es una recomendación final.",
          crop_rotation_final_requires_gaucho_gates:
            "La rotación final requiere las compuertas de evidencia de Gaucho (objetivo post-cosecha, ventana de siembra, disponibilidad de agua, evidencia de suelo).",
          crop_rotation_requires_human_review:
            "La recomendación de rotación requiere revisión humana.",
        },
      },
      userReadinessChecklist: {
        calculatedRecommendationBlocked: "Calculado · recomendación bloqueada",
        sectionTitle: "Qué necesita Gaucho de ti",
        groups: {
          required: "Información requerida por el productor",
          recommended: "Evidencia recomendada",
          why: "Por qué importa",
        },
        status: {
          completed: "Completado",
          needed: "Necesario",
          recommended: "Recomendado",
          not_requested: "No requerido",
        },
        items: {
          harvest_status: "Estado de cosecha",
          next_planned_crop: "Próximo cultivo previsto",
          post_harvest_objective: "Objetivo post-cosecha",
          planting_window: "Ventana de siembra",
          water_availability: "Disponibilidad de agua",
          recent_irrigation: "Actividad reciente de riego",
          field_validation: "Validación en campo (solo cuando se solicita)",
          soil_or_foliar_analysis: "Análisis de suelo o foliar",
          satellite_ndvi_refresh: "Actualización satelital / NDVI",
          fao56_irrigation_calculation: "Cálculo de riego FAO-56",
          weather_forecast: "Previsión meteorológica",
          pest_disease_scouting: "Scouting sanitario",
          fire_risk_context: "Contexto de riesgo de incendio",
        },
        summary: {
          allComplete:
            "Toda la información requerida del productor está completa para esta ventana.",
          someNeeded:
            "Para mejorar la recomendación de Gaucho, actualiza los puntos siguientes.",
        },
        blocker: {
          fao56AndPlanning:
            "Gaucho está bloqueado principalmente porque faltan evidencia FAO-56 de riego e información de planificación del cultivo.",
          fao56Only:
            "Gaucho está bloqueado principalmente porque la evidencia FAO-56 de riego está incompleta.",
          planningOnly:
            "Gaucho está bloqueado principalmente porque falta información de planificación del cultivo.",
        },
        whyBody:
          "Gaucho no puede validar riego, rotación o prioridades de riesgo hasta que la información requerida esté completa.",
      },
      readiness: {
        sectionTitle: "Preparar Gaucho",
        sectionSubtitle:
          "Completa estos datos para mejorar el análisis de Gaucho. Los datos faltantes no generan evidencia ficticia — Gaucho mantendrá los módulos afectados en estado de revisión o no conectado. La preparación no habilita ejecución real en campo.",
        howToStartTitle: "Cómo empezar con Gaucho",
        howToStartSteps: [
          "Crea o selecciona una parcela real.",
          "Confirma la información de cultivo y temporada.",
          "Verifica la disponibilidad satelital y de vegetación.",
          "Añade evidencia de suelo/foliar si quieres contexto de fertilidad.",
          "Ejecuta manualmente el análisis ML de riesgo o económico si quieres contexto de riesgo.",
          "Añade observaciones de campo.",
          "Revisa las recomendaciones de Gaucho y el Plan de Acción.",
          "Aprueba/rechaza paquetes supervisados L4 solo como revisión manual, no como ejecución.",
        ],
        scoreLabel: "Preparación",
        levels: {
          basic: "Básica",
          partial: "Parcial",
          strong: "Sólida",
          blocked: "Bloqueada",
        },
        requiredLevels: {
          required_basic: "Requerido",
          required_advanced: "Requerido para avanzado",
          recommended: "Recomendado",
          optional: "Opcional",
        },
        statuses: {
          available: "Disponible",
          missing: "Faltante",
          not_connected: "No conectado",
          insufficient: "Insuficiente",
          not_checked: "No verificado",
        },
        groups: {
          parcel_identity: "Identidad de parcela",
          crop_season: "Cultivo y temporada",
          satellite_context: "Satélite y vegetación",
          water_irrigation: "Agua y riego",
          soil_fertility: "Suelo y fertilidad",
          risk_economic: "Riesgo y económico",
          field_observations: "Observaciones de campo",
          reporting_traceability: "Reportes y trazabilidad",
        },
        modulesLimited: "Módulos limitados por datos faltantes",
        noModulesLimited: "Ningún módulo está actualmente limitado por datos faltantes.",
        safetyNote:
          "La preparación es solo informativa. No habilita puertas de evidencia, ejecución ni ejecuta automáticamente ningún análisis pagado.",
      },
      actionPlan: {
        title: "Plan de acciones",
        humanReviewBadge: "Requiere revisión humana",
        status: {
          proposed: "Propuesta",
          accepted: "Aceptada",
          in_progress: "En curso",
          completed: "Completada",
          dismissed: "Descartada",
          expired: "Expirada",
          blocked: "Bloqueada",
        },
        btn: {
          accept: "Aceptar",
          inProgress: "Marcar en curso",
          completed: "Marcar completada",
          dismiss: "Descartar",
        },
        executionBlockedNotice:
          "Ejecución bloqueada — no hay acciones de ciclo disponibles.",
      },
      recommendationPresentation: {
        primaryTitle: "Prioridades ahora",
        secondaryTitle: "Otras recomendaciones",
        whyPrimary: "Por qué importa ahora",
        reasons: {
          urgency_critical: "Falta evidencia requerida",
          urgency_high: "Alta relevancia operativa",
          urgency_medium: "Relevancia operativa media",
          urgency_low: "Baja relevancia operativa",
          urgency_informational: "Informativo",
          user_actionable: "Puede actuar sobre esto",
          limited_evidence: "Evidencia limitada / de referencia",
          missing_required_evidence: "Falta evidencia requerida",
          evidence_blocker: "Cálculo bloqueado por falta de evidencia",
        },
      },
      operationalRecommendations: {
        title: "Recomendaciones de Gaucho",
        subtitle:
          "Recomendaciones basadas en evidencia y vinculadas al plan de acción de la parcela.",
        humanReviewBadge: "Requiere revisión humana",
        empty:
          "Aún no hay recomendaciones. Complete la evidencia y confirmaciones requeridas para desbloquear la guía de Gaucho.",
        evidenceUsed: "Evidencia utilizada",
        missingEvidence: "Evidencia faltante",
        linkedActions: "Acciones vinculadas",
        linkedActionsCount_one: "{{count}} acción vinculada",
        linkedActionsCount_other: "{{count}} acciones vinculadas",
        linkedActionsNone: "Ninguna aún",
        nextStep: "Próximo paso recomendado",
        categories: {
          irrigation: "Riego",
          vegetation: "Vegetación",
          water_stress: "Contexto hídrico",
          crop_rotation: "Rotación de cultivo",
          pest_disease: "Plagas y enfermedades",
          fire_risk: "Riesgo de incendio",
          weather: "Clima",
          soil_foliar: "Suelo y foliar",
          reporting: "Informes",
          general_operations: "Operaciones generales",
        },
        statuses: {
          ready: "Lista",
          needs_input: "Requiere datos",
          blocked: "Bloqueada",
          review_required: "Requiere revisión",
        },
        titles: {
          irrigation_ready: "Revisar demanda hídrica del cultivo y estado hídrico actual",
          irrigation_canonical_target_review:
            "Revisar el objetivo NETO canónico de riego",
          irrigation_target_not_triggered: "Sin objetivo NETO de riego propuesto",
          irrigation_target_blocked: "Objetivo NETO canónico de riego bloqueado",
          irrigation_target_unavailable: "Objetivo NETO canónico de riego no disponible",
          irrigation_target_system_error:
            "Objetivo NETO canónico de riego no legible",
          irrigation_blocked: "Completar evidencia de riego",
          vegetation_validate: "Validar señal de vegetación en campo",
          water_context: "Revisar contexto hídrico",
          crop_rotation_needs_input: "Completar datos de rotación",
          crop_rotation_review: "Revisar plan de rotación",
          pest_scouting: "Explorar riesgo de plagas o enfermedades",
          fire_prevention: "Revisar prevención de incendios",
          soil_foliar_evidence: "Subir evidencia de suelo o foliar",
          reporting_review: "Revisar evidencia de cumplimiento",
        },
        summaries: {
          irrigation_ready:
            "La evidencia FAO-56 de demanda hídrica del cultivo está disponible para revisión. No hay ninguna cantidad de riego a aplicar disponible actualmente.",
          irrigation_canonical_target_review:
            "Hay un objetivo NETO canónico de riego disponible para revisión humana supervisada. Es un objetivo NETO en zona radicular, no una lámina bruta aplicada, ni una duración ni una programación.",
          irrigation_target_not_triggered:
            "La decisión canónica no propone ningún objetivo NETO de riego: no se ha alcanzado el umbral de manejo revisado.",
          irrigation_target_blocked:
            "El objetivo NETO canónico de riego está bloqueado. No hay ninguna cantidad de aplicación disponible desde ninguna otra fuente.",
          irrigation_target_unavailable:
            "No hay ningún objetivo NETO canónico de riego disponible para esta parcela y día.",
          irrigation_target_system_error:
            "El objetivo NETO canónico de riego no pudo resolverse por un error de lectura.",
          irrigation_blocked:
            "Gaucho no puede sostener una decisión de riego hasta que se complete la evidencia FAO-56.",
          vegetation_validate:
            "La evidencia satelital muestra variabilidad en la vegetación. La causa no está confirmada.",
          water_context:
            "Existen señales de contexto hídrico. Describen estrés, no una decisión de riego.",
          crop_rotation_needs_input:
            "La planificación de rotación no puede avanzar hasta completar los datos humanos faltantes.",
          crop_rotation_review:
            "Los datos de planificación de rotación están completos. Revise la guía antes de decidir.",
          pest_scouting:
            "Los indicadores sugieren explorar en campo. Gaucho no confirma un brote de plaga o enfermedad.",
          fire_prevention:
            "Hay indicadores de riesgo de incendio. Revise las acciones preventivas y las fuentes oficiales.",
          soil_foliar_evidence:
            "No se encontró evidencia persistida de suelo o foliar para esta parcela.",
          reporting_review:
            "Hay evidencia de cumplimiento y auditoría disponible. Revísela antes de generar un informe.",
        },
        rationales: {
          irrigation_ready:
            "La evidencia de ET0 / ETc y Kc dual describe la demanda atmosférica, la evapotranspiración del cultivo y el estado del balance hídrico. Por sí misma no define un objetivo de aplicación de riego.",
          irrigation_canonical_target_review:
            "La decisión canónica supervisada resolvió un objetivo NETO en zona radicular a partir del estado hídrico modelado y de la política de manejo revisada. Gaucho lo copia literalmente y no añade ningún cálculo.",
          irrigation_target_not_triggered:
            "No se ha alcanzado el umbral de manejo revisado, por lo que la decisión canónica no propone ningún objetivo NETO. La ETc sigue siendo únicamente demanda de referencia.",
          irrigation_target_blocked:
            "La decisión canónica está bloqueada por un requisito de evidencia no cumplido. Gaucho no sustituye con una cantidad derivada de la ETc.",
          irrigation_target_unavailable:
            "La decisión canónica no pudo resolverse para esta parcela y día. No existe ningún objetivo de riego.",
          irrigation_target_system_error:
            "No se pudo leer el estado hídrico canónico. Gaucho falla en cerrado y no muestra ningún objetivo.",
          irrigation_blocked:
            "Gaucho no relaja la puerta FAO-56. La evidencia faltante mantiene bloqueada la decisión de riego.",
          vegetation_validate:
            "NDVI, NDRE, zonas de vigor y anomalías indican solo variabilidad espacial. Gaucho no infiere sequía, deficiencia nutricional, plaga o enfermedad solo desde satélite.",
          water_context_ready:
            "La humedad satelital, el contexto de sequía y la demanda atmosférica son informativos. Cualquier decisión de riego pasa por la puerta FAO-56.",
          water_context_blocked:
            "El contexto hídrico es solo informativo. La decisión de riego sigue bloqueada mientras la evidencia FAO-56 esté incompleta.",
          crop_rotation_needs_input:
            "La planificación de rotación requiere datos humanos como estado de cosecha, próximo cultivo planificado, objetivo post-cosecha, ventana de siembra y disponibilidad de agua.",
          crop_rotation_review:
            "La guía de planificación de rotación es solo planificación. Gaucho no recomienda especie, mezcla de semillas ni ejecución de siembra.",
          pest_scouting:
            "Gaucho recomienda exploración de campo o revisión agronómica. No se propone ningún producto, ingrediente activo ni dosis.",
          fire_prevention:
            "Gaucho recomienda revisar acciones preventivas y fuentes oficiales. Gaucho no reemplaza a los servicios de emergencia.",
          soil_foliar_evidence:
            "Las decisiones de fertilización y nutrición requieren evidencia persistida de suelo o foliar.",
          reporting_review:
            "La generación de informes es informativa. Gaucho no envía reclamaciones de seguros, legales ni de PAC.",
        },
        nextSteps: {
          irrigation_review:
            "Revise el estado hídrico canónico y la evidencia de campo faltante con un agrónomo.",
          irrigation_review_canonical_target:
            "Revise el objetivo NETO canónico de riego con un agrónomo antes de decidir o aplicar cualquier riego.",
          irrigation_complete_fao56:
            "Complete la evidencia FAO-56 (ET0, ETc, Kc dual, pronóstico 7 días) o confirme que no hay riego para esta ventana.",
          vegetation_field_check:
            "Abra la zona afectada en campo y registre una nota de exploración o validación.",
          water_review_context:
            "Revise el contexto hídrico junto con la evidencia FAO-56 en el Optimizador de Riego.",
          crop_rotation_complete_inputs:
            "Confirme el estado de cosecha, declare el próximo cultivo planificado y el objetivo post-cosecha, y complete la ventana de siembra y la disponibilidad de agua.",
          crop_rotation_review_plan:
            "Abra la sección de planificación de rotación de cultivos y revise la guía con un agrónomo.",
          pest_scouting:
            "Abra Plagas y Enfermedades y registre una observación de exploración para la zona afectada.",
          fire_official_review:
            "Revise las fuentes oficiales de riesgo de incendio (protección civil / EFFIS) y la preparación preventiva.",
          soil_foliar_upload:
            "Suba un análisis de suelo o foliar reciente para habilitar la guía de fertilización.",
          reporting_review:
            "Abra el Centro de Informes para revisar la evidencia de cumplimiento y auditoría disponible.",
        },
        safety: {
          irrigation_no_execution:
            "No se produce ninguna cantidad, programación ni ejecución de riego. Gaucho nunca abre válvulas, arranca bombas ni activa el riego automáticamente.",
          irrigation_canonical_target_only:
            "Cualquier objetivo NETO de riego mostrado aquí se copia de la decisión canónica supervisada. Gaucho nunca lo recalcula ni deriva una cantidad de aplicación a partir de la ETc.",
          irrigation_canonical_target_not_loaded:
            "La decisión canónica del objetivo NETO no se cargó, por lo que no se implica ninguna disponibilidad de objetivo de aplicación.",
          vegetation_no_cause_inferred:
            "La evidencia satelital por sí sola no confirma la causa. No infiera sequía, deficiencia, plaga ni enfermedad sin validación en campo.",
          water_no_execution:
            "El contexto hídrico es informativo. Nunca desencadena la ejecución de riego.",
          crop_rotation_no_species:
            "Gaucho no recomienda un cultivo, especie o mezcla de semillas específica.",
          pest_no_treatment:
            "Gaucho nunca propone un pesticida, fungicida, herbicida, ingrediente activo ni aplicación.",
          fire_no_emergency:
            "Gaucho no emite instrucciones de emergencia ni reemplaza a los servicios de protección civil.",
          soil_no_fertilizer:
            "Gaucho no recomienda un producto o dosis de fertilizante sin evidencia persistida de suelo o foliar.",
          reporting_no_claim:
            "Gaucho no envía reclamaciones de seguros, legales o de PAC de forma automática.",
        },
        progress: {
          label: "Progreso",
          countsSuffix: "{{completed}}/{{total}}",
          summary: {
            no_linked_action: "Sin acciones vinculadas",
            not_started: "Sin iniciar",
            accepted: "Aceptadas",
            in_progress: "En progreso",
            completed: "Todas las acciones completadas",
            partially_completed: "Parcialmente completado",
            dismissed: "Todas descartadas",
            blocked: "Acción bloqueada",
            expired: "Acción expirada",
            mixed: "Progreso mixto",
          },
        },
        progressStates: {
          no_linked_action: "Sin acciones vinculadas",
          not_started: "Sin iniciar",
          accepted: "Aceptadas",
          in_progress: "En progreso",
          completed: "Completadas",
          partially_completed: "Parcialmente completado",
          dismissed: "Descartadas",
          blocked: "Bloqueada",
          expired: "Expirada",
          mixed: "Mixto",
        },
        nextBestAction: {
          badge: "Siguiente paso sugerido",
          labels: {
            record_field_observation: "Registrar detalles de la observación de campo",
            record_scouting_findings: "Registrar hallazgos de monitoreo",
            review_fao56_recommendation: "Revisar la recomendación FAO-56",
            review_uploaded_soil_foliar_analysis:
              "Revisar el análisis de suelo o foliar cargado",
            review_or_export_evidence_report:
              "Revisar o exportar el informe de evidencia",
            review_recommendation_open_status:
              "Revisar si esta recomendación sigue abierta",
            review_missing_evidence: "Revisar la evidencia faltante",
            review_timing_or_applicability: "Revisar la vigencia o aplicabilidad",
            continue_in_progress_action: "Continuar la acción en curso",
            start_linked_action: "Comenzar revisando la acción vinculada",
            wait_for_action_completion: "Completar o actualizar la acción vinculada",
            review_mixed_progress: "Revisar el progreso mixto de las acciones",
            no_safe_follow_up: "No hay un seguimiento seguro disponible",
          },
          rationales: {
            record_field_observation:
              "La validación de campo está completa. El siguiente paso seguro es registrar lo observado.",
            record_scouting_findings:
              "El monitoreo está completo. El siguiente paso seguro es documentar los hallazgos.",
            review_fao56_recommendation:
              "La confirmación del registro de riego está completa. Revisar la recomendación FAO-56 es el siguiente paso seguro.",
            review_uploaded_soil_foliar_analysis:
              "La carga de evidencia de suelo o foliar está completa. El siguiente paso seguro es revisar el análisis cargado.",
            review_or_export_evidence_report:
              "La revisión de reportes está completa. El siguiente paso seguro es la revisión o exportación de evidencia.",
            review_recommendation_open_status:
              "El trabajo vinculado está cerrado, pero Gaucho no cierra recomendaciones automáticamente.",
            review_missing_evidence:
              "El trabajo vinculado está bloqueado. Revise la evidencia faltante y el contexto.",
            review_timing_or_applicability:
              "La acción vinculada expiró. Revise si esta recomendación sigue vigente.",
            continue_in_progress_action:
              "El trabajo vinculado está en curso. Gaucho espera la evidencia de finalización.",
            start_linked_action:
              "Las acciones vinculadas aún no han comenzado. Revíselas antes de iniciarlas.",
            wait_for_action_completion:
              "La acción vinculada fue aceptada o parcialmente completada. Complétela o actualícela.",
            review_mixed_progress:
              "Las acciones vinculadas tienen estados mixtos. Se requiere revisión humana.",
            no_safe_follow_up:
              "No hay un seguimiento seguro disponible para esta recomendación.",
          },
          safety: {
            no_cause_inference:
              "No inferir causa a partir de una sola observación de campo.",
            no_pest_disease_confirmation:
              "No confirmar automáticamente un brote de plaga o enfermedad.",
            no_treatment_product_dose:
              "No proponer tratamientos, productos ni dosis.",
            no_irrigation_execution:
              "No programar ni ejecutar riego automáticamente.",
            no_fertilizer_product_dose:
              "No proponer productos fertilizantes ni dosis sin análisis persistido.",
            no_claim_or_legal_submission:
              "No enviar automáticamente reclamaciones de seguros, legales ni PAC.",
            no_evidence_fabrication:
              "No fabricar evidencia para desbloquear una compuerta.",
            no_gate_bypass: "No omitir las compuertas de evidencia.",
            no_auto_recreation:
              "No recrear la acción vinculada automáticamente.",
            no_auto_resolution:
              "No resolver la recomendación automáticamente.",
          },
        },
      },
      actionObservations: {
          title: "Observaciones de campo",
          subtitle:
            "Adjunte notas de evidencia humana a acciones en curso o completadas.",
          empty: "Aún no hay observaciones humanas registradas.",
          add: "Añadir observación de campo",
          noteLabel: "Nota de la observación",
          typeLabel: "Tipo de observación",
          severityLabel: "Severidad",
          photoReferenceLabel: "Referencia de foto (opcional)",
          save: "Guardar observación",
          saving: "Guardando…",
          saved: "Observación guardada",
          attachedBadge: "Observación humana adjunta",
          humanEvidenceAttached: "Evidencia humana adjunta",
          safetyNotice:
            "Las observaciones son notas de evidencia humana. Gaucho no infiere causas ni ejecuta acciones a partir de ellas.",
          errors: {
            statusNotAllowed:
              "Solo se pueden adjuntar observaciones a acciones en curso o completadas.",
            noteTooShort:
              "La nota es demasiado corta (mínimo 3 caracteres).",
            noteTooLong:
              "La nota es demasiado larga (máximo 1200 caracteres).",
            photoReferenceTooLong:
              "La referencia de foto es demasiado larga (máximo 500 caracteres).",
          },
          types: {
            field_note: "Nota de campo",
            scouting_note: "Nota de monitoreo",
            water_context_note: "Nota de contexto hídrico",
            soil_foliar_note: "Nota de suelo o foliar",
            reporting_note: "Nota de reportes",
            general_note: "Nota general",
          },
          severities: {
            unspecified: "Sin especificar",
            low: "Baja",
            medium: "Media",
            high: "Alta",
          },
          safety: {
            no_cause_inference:
              "No inferir causa a partir de una sola observación de campo.",
            no_pest_disease_confirmation:
              "No confirmar automáticamente un brote de plaga o enfermedad.",
            no_treatment_product_dose:
              "No proponer tratamientos, productos ni dosis.",
            no_irrigation_execution:
              "No programar ni ejecutar riego automáticamente.",
            no_fao56_gate_bypass:
              "No omitir las compuertas de evidencia FAO-56.",
            no_fertilizer_product_dose:
              "No proponer productos fertilizantes ni dosis sin análisis persistido.",
            no_nutrient_diagnosis_without_analysis:
              "No diagnosticar el estado nutricional sin un análisis persistido.",
            no_claim_or_legal_submission:
              "No enviar automáticamente reclamaciones de seguros, legales ni PAC.",
            no_auto_resolution:
              "No resolver la recomendación automáticamente.",
          },
      },
        observationSummary: {
          title: "Resumen de observaciones humanas",
          badge: "Resumen de observaciones humanas",
          empty: "Aún no hay observaciones humanas vinculadas.",
          count_one: "{{count}} observación registrada",
          count_other: "{{count}} observaciones registradas",
          latest: "Última observación",
          notes: "Notas registradas",
          severity: "Severidad",
          attachedBadge: "Evidencia humana adjunta",
          noteLabel: "Nota de observación",
          types: {
            field_note: "Nota de campo",
            scouting_note: "Nota de monitoreo",
            water_context_note: "Nota de contexto hídrico",
            soil_foliar_note: "Nota de suelo o foliar",
            reporting_note: "Nota de reportes",
            general_note: "Nota general",
          },
          severities: {
            unspecified: "Sin especificar",
            low: "Baja",
            medium: "Media",
            high: "Alta",
          },
          summaries: {
            vegetation:
              "Notas de campo registradas por el usuario vinculadas a la revisión de vegetación.",
            water_stress:
              "Notas registradas por el usuario vinculadas a la revisión del contexto hídrico.",
            irrigation:
              "Notas registradas por el usuario vinculadas a la revisión de riego.",
            pest_disease:
              "Notas de monitoreo registradas por el usuario vinculadas a la revisión de plagas y enfermedades.",
            soil_foliar:
              "Notas registradas por el usuario vinculadas a la revisión de evidencia de suelo o foliar.",
            reporting:
              "Notas registradas por el usuario vinculadas a la revisión de reportes.",
            crop_rotation:
              "Notas registradas por el usuario vinculadas a la revisión de rotación de cultivos.",
            fire_risk:
              "Notas registradas por el usuario vinculadas a la revisión de riesgo de incendio.",
            weather:
              "Notas registradas por el usuario vinculadas a la revisión meteorológica.",
            general:
              "Notas registradas por el usuario vinculadas a esta recomendación.",
          },
          safety: {
            no_cause_inference:
              "Gaucho no infiere causas a partir de observaciones humanas.",
            no_irrigation_execution:
              "Gaucho no programa ni inicia riego a partir de observaciones humanas.",
            no_fao56_gate_bypass:
              "Las observaciones humanas no omiten las compuertas de evidencia FAO-56.",
            no_pest_disease_confirmation:
              "Gaucho no confirma brotes de plagas o enfermedades a partir de observaciones humanas.",
            no_treatment_product_dose:
              "Gaucho no propone tratamientos, productos ni dosis.",
            no_fertilizer_product_dose:
              "Gaucho no propone productos fertilizantes ni dosis a partir de observaciones humanas.",
            no_nutrient_diagnosis_without_analysis:
              "Gaucho no diagnostica el estado nutricional sin un análisis persistido.",
            no_claim_or_legal_submission:
              "Gaucho no envía reclamaciones de seguros, legales ni PAC a partir de observaciones humanas.",
            no_sowing_or_planting_execution:
              "Gaucho no programa siembras ni plantaciones a partir de observaciones humanas.",
            no_emergency_decision:
              "Gaucho no toma decisiones de emergencia a partir de observaciones humanas.",
            no_automatic_weather_action:
              "Gaucho no actúa automáticamente sobre señales meteorológicas.",
            no_auto_resolution:
              "Gaucho no resuelve la recomendación automáticamente.",
          },
        },
        supervisedActionPackage: {
          title: "Paquete de acción supervisada",
          subtitle:
            "Paquete estructurado preparado para revisión humana. No es automático. Requiere aprobación.",
          badge: "L4 · Preparación supervisada",
          autonomyLevel: "L4 preparación de acción supervisada",
          approvalRequired: "Aprobación requerida",
          linkedRecommendation: "Recomendación vinculada",
          linkedAction: "Acción vinculada",
          evidenceUsed: "Evidencia utilizada",
          missingEvidence: "Evidencia faltante",
          humanObservationCount_one:
            "{{count}} observación humana vinculada",
          humanObservationCount_other:
            "{{count}} observaciones humanas vinculadas",
          canBeApproved: "Elegible para aprobación manual",
          reviewOnly:
            "Solo revisión — aprobación bloqueada para esta categoría",
          status: {
            draft: "Borrador",
            review_required: "Requiere revisión",
            blocked: "Bloqueado",
          },
          allowedReviewActions: {
            approve_for_manual_followup:
              "Aprobar para seguimiento manual",
            reject: "Rechazar",
            mark_blocked: "Marcar bloqueado",
          },
          blockedReasons: {
            no_linked_action:
              "No hay acción vinculada disponible para esta recomendación.",
            action_not_ready:
              "La acción vinculada no está aceptada, en progreso ni completada.",
            recommendation_blocked:
              "La recomendación está actualmente bloqueada.",
            critical_missing_evidence:
              "Falta evidencia crítica. Aporte primero las entradas requeridas.",
          },
          categories: {
            vegetation: "Vegetación",
            water_stress: "Contexto hídrico",
            irrigation: "Riego",
            pest_disease: "Plagas y enfermedades",
            soil_foliar: "Suelo y foliar",
            reporting: "Reportes",
            crop_rotation: "Rotación de cultivos",
            fire_risk: "Riesgo de incendio",
            weather: "Meteorología",
            general_operations: "Operaciones generales",
          },
          titles: {
            vegetation:
              "Paquete de seguimiento de campo de vegetación",
            water_stress:
              "Paquete de revisión de contexto hídrico",
            irrigation: "Paquete de revisión FAO-56",
            pest_disease: "Paquete de revisión de monitoreo",
            soil_foliar:
              "Paquete de revisión de evidencia de suelo y foliar",
            reporting: "Paquete de revisión de reportes",
            crop_rotation:
              "Paquete de revisión de planificación de rotación",
            fire_risk:
              "Paquete de revisión preventiva de riesgo de incendio",
            weather: "Paquete de revisión meteorológica",
            general_operations:
              "Paquete de revisión manual general",
          },
          summaries: {
            vegetation:
              "Seguimiento manual de campo preparado para revisión humana. No es automático.",
            water_stress:
              "Revisión de contexto hídrico preparada para revisión humana. No se programa riego.",
            irrigation:
              "Revisión FAO-56 preparada para revisión humana. No se propone bomba, válvula ni volumen.",
            pest_disease:
              "Revisión de monitoreo preparada para revisión humana. Sin confirmación, sin tratamiento.",
            soil_foliar:
              "Revisión de evidencia de laboratorio preparada para revisión humana. Sin producto fertilizante ni dosis.",
            reporting:
              "Revisión de reportes preparada para revisión humana. Sin envío legal, de seguros ni PAC.",
            crop_rotation:
              "Revisión de planificación preparada para revisión humana. Sin instrucción de siembra ni plantación.",
            fire_risk:
              "Revisión preventiva preparada para revisión humana. Sin decisión de emergencia.",
            weather:
              "Revisión meteorológica preparada para revisión humana. Sin acción meteorológica automática.",
            general_operations:
              "Paquete de revisión manual preparado para revisión humana.",
          },
          safety: {
            not_automatic: "No es automático.",
            requires_human_review: "Requiere revisión humana.",
            approval_required:
              "Aprobación requerida antes de cualquier seguimiento.",
            no_autonomous_action: "Sin acción autónoma.",
            no_real_execution:
              "Sin ejecución en el mundo real desde este paquete.",
            no_cause_inference: "No infiere causa agronómica.",
            no_irrigation_execution: "No programa ni inicia riego.",
            no_fao56_gate_bypass:
              "No omite las compuertas de evidencia FAO-56.",
            no_pest_disease_confirmation:
              "No confirma brotes de plagas ni enfermedades.",
            no_treatment_product_dose:
              "No propone tratamientos, productos ni dosis.",
            no_fertilizer_product_dose:
              "No propone productos fertilizantes ni dosis.",
            no_nutrient_diagnosis_without_analysis:
              "No diagnostica el estado nutricional sin análisis persistido.",
            no_claim_or_legal_submission:
              "No envía reclamaciones de seguros, legales ni PAC.",
            no_sowing_or_planting_execution:
              "No programa siembras ni plantaciones.",
            no_emergency_decision:
              "No toma decisiones de emergencia.",
            no_automatic_weather_action:
              "No actúa automáticamente sobre señales meteorológicas.",
            no_auto_resolution:
              "No resuelve la recomendación automáticamente.",
            review_only_sensitive_category:
              "Solo revisión. Esta categoría no es elegible para aprobación manual en esta capa de preparación.",
          },
        },
        supervisedActionReview: {
          title: "Auditoría de revisión humana",
          subtitle:
            "Solo registra una decisión de revisión humana. No se activa ninguna acción automática. Únicamente seguimiento manual.",
          latestDecision: "Última decisión",
          historyCount_one: "{{count}} registro de revisión",
          historyCount_other: "{{count}} registros de revisión",
          decisionNoteLabel:
            "Nota del revisor (opcional, máximo 1200 caracteres)",
          decisionNotePlaceholder:
            "Añade una breve nota humana sobre esta decisión de revisión.",
          recordDecision: "Registrar decisión",
          saving: "Guardando…",
          saved: "Guardado.",
          error:
            "No se pudo guardar la decisión de revisión. No se realizó ninguna acción. Inténtelo de nuevo.",
          decisions: {
            approve_for_manual_followup: "Aprobar seguimiento manual",
            reject: "Rechazar paquete",
            mark_blocked: "Marcar paquete como bloqueado",
          },
          blockedReasons: {
            approvalNotAllowed:
              "El seguimiento manual no está permitido para este paquete.",
            noteTooLong:
              "La nota del revisor es demasiado larga. Redúzcala a 1200 caracteres o menos.",
          },
          safety: {
            human_review_audit_only: "Solo auditoría de revisión humana.",
            no_automatic_action: "No se activa ninguna acción automática.",
            review_only_no_irrigation_action:
              "Solo revisión. No programa ni inicia riego.",
            review_only_no_treatment_action:
              "Solo revisión. No propone ni inicia ningún tratamiento.",
            review_only_no_fertilizer_action:
              "Solo revisión. No propone ni inicia ningún plan de fertilización.",
            review_only_no_submission_action:
              "Solo revisión. No envía ninguna comunicación de seguros, legal ni PAC.",
            review_only_no_emergency_action:
              "Solo revisión. No inicia ni despacha una respuesta de emergencia.",
          },
        },
      moduleEvidenceRegistry: {
        sectionTitle: "Registro de evidencia de módulos",
        sectionSubtitle:
          "Registro central que mapea los módulos de SentinelCrop a dominios de evidencia, clases de seguridad y niveles de integración de Gaucho. Solo lectura. No ejecuta operaciones de campo, no propone productos ni dosis, y no autoriza acciones de riego, fertilización, emergencia, seguros, legales ni PAC.",
        modules: {
          drought_water_stress: "Sequía y estrés hídrico",
          ml_risk_analysis: "Análisis de riesgo ML",
          economic_risk_impact: "Impacto de riesgo económico",
          nitrogen_optimizer: "Optimizador de nitrógeno",
          pk_fertilization_optimizer: "Optimizador de fertilización P y K",
          irrigation_optimizer: "Optimizador de riego",
          advanced_vegetation_analysis: "Análisis avanzado de vegetación",
          satellite_view: "Vista satelital",
          crop_seasons: "Temporadas de cultivo",
          phenology_gdd: "Fenología y GDD",
          soil_foliar_analysis: "Análisis de suelo y foliar",
          reports_center: "Centro de reportes",
          fire_risk: "Riesgo de incendio",
          pest_disease: "Riesgo de plagas y enfermedades",
          crop_rotation_advisor: "Asesor de rotación de cultivos",
          parcel_memory: "Memoria de parcela",
          field_activities: "Actividades de campo",
        },
        statuses: {
          working: "Operativo",
          partially_working: "Parcialmente operativo",
          broken: "No operativo",
          not_tested: "Sin probar",
        },
        integrationLevels: {
          not_integrated: "No integrado en Gaucho",
          auxiliary_visible: "Auxiliar y solo visible",
          primary_evidence: "Entrada de evidencia primaria",
          creates_recommendation: "Puede generar una recomendación",
          creates_action_plan: "Puede crear una fila del Plan de Acción",
          influences_progress: "Puede influir en el estado de progreso",
          influences_nba: "Puede influir en la sugerencia de próxima mejor acción",
          l4_supervised_package: "Puede aparecer en un paquete de acción supervisada",
          l4_audit_included: "Incluido en el registro de auditoría de revisión supervisada",
        },
        safetyClasses: {
          safe_informational: "Contexto informativo seguro",
          evidence_gated: "Restringido por evidencia",
          review_only: "Solo revisión. No ejecuta ninguna acción automática.",
          sensitive_agronomic:
            "Contexto agronómico sensible. Solo revisión. No propone productos ni dosis.",
          blocked_from_approval:
            "No apto para aprobación supervisada. Solo seguimiento humano.",
          non_binding_risk_estimate:
            "Estimación de riesgo no vinculante. No es una declaración de seguros, legal ni PAC.",
        },
        evidenceDomains: {
          water: "Agua",
          vegetation: "Vegetación",
          risk: "Riesgo",
          economic: "Económico",
          fertility: "Fertilidad",
          irrigation: "Riego",
          phenology: "Fenología",
          crop_lifecycle: "Ciclo del cultivo",
          reporting: "Reportes",
          fire: "Incendio",
          pest_disease: "Plagas y enfermedades",
          memory: "Memoria",
          field_activity: "Actividad de campo",
          general: "General",
        },
        usageSummaries: {
          drought_water_stress_current:
            "La sequía y el estrés hídrico se usan solo como contexto auxiliar. No programa ni autoriza riego.",
          drought_water_stress_target:
            "Uso previsto: generar una recomendación de revisión de contexto hídrico. No ejecuta riego.",
          ml_risk_current:
            "El análisis de riesgo ML no está integrado en Gaucho hoy. Sus salidas no afectan recomendaciones ni gates.",
          ml_risk_target:
            "Uso previsto: mostrar contexto de riesgo no vinculante para revisión humana. No confirma daño ni activa siniestros.",
          economic_risk_current:
            "El impacto de riesgo económico no está integrado en Gaucho hoy. Sus salidas no afectan recomendaciones ni gates.",
          economic_risk_target:
            "Uso previsto: mostrar contexto económico no vinculante para revisión humana. No representa una decisión de seguros, legal ni PAC.",
          nitrogen_current:
            "El optimizador de nitrógeno no está integrado en Gaucho hoy. No propone productos, dosis ni aplicaciones a través del asesor.",
          nitrogen_target:
            "Uso previsto: mostrar contexto de fertilidad solo para revisión. Nunca propondrá un producto, dosis ni aplicación a través del asesor.",
          pk_current:
            "El optimizador de P y K no está integrado en Gaucho hoy. No propone productos, dosis ni aplicaciones a través del asesor.",
          pk_target:
            "Uso previsto: mostrar contexto de fertilidad solo para revisión. Nunca propondrá un producto, dosis ni aplicación a través del asesor.",
          irrigation_current:
            "El contexto del optimizador de riego es solo visible. No programa ni inicia riego.",
          irrigation_target:
            "Uso previsto: exponer contexto de riego solo para revisión. Nunca programará ni iniciará riego.",
          vegetation_current:
            "El análisis avanzado de vegetación se usa como evidencia primaria. La causa no se infiere solo desde satélite.",
          vegetation_target:
            "Uso previsto: continúa como evidencia primaria de vegetación, con validación de campo requerida para la causa.",
          satellite_current:
            "La vista satelital aporta contexto informativo de imagen. La causa no se infiere solo desde satélite.",
          satellite_target:
            "Uso previsto: continúa como contexto informativo de imagen.",
          crop_seasons_current:
            "Las temporadas de cultivo aportan contexto de ciclo de vida solo visible.",
          crop_seasons_target:
            "Uso previsto: pasar a ser evidencia primaria de ciclo de vida con confirmación humana.",
          phenology_gdd_current:
            "Fenología y GDD son auxiliares. GDD no habilita fenología, FAO-56 ni ningún otro gate hoy.",
          phenology_gdd_target:
            "Uso previsto: continúa como auxiliar. Cualquier uso en gates requiere un cambio explícito revisado por separado.",
          soil_foliar_current:
            "El análisis de suelo y foliar es solo visible. No diagnostica estado nutricional ni propone productos o dosis sin un análisis persistido.",
          soil_foliar_target:
            "Uso previsto: contexto de fertilidad solo para revisión. Nunca propondrá productos ni dosis sin un análisis persistido.",
          reports_current:
            "El centro de reportes es solo visible. No envía acciones de seguros, legales ni PAC.",
          reports_target:
            "Uso previsto: continúa como documentación solo para revisión. Nunca enviará acciones de seguros, legales ni PAC.",
          fire_current:
            "El riesgo de incendio es solo visible. No inicia ni despacha respuesta de emergencia.",
          fire_target:
            "Uso previsto: continúa como contexto de riesgo solo para revisión. Nunca iniciará ni despachará respuesta de emergencia.",
          pest_disease_current:
            "El riesgo de plagas y enfermedades es solo visible. No propone productos, dosis ni aplicaciones.",
          pest_disease_target:
            "Uso previsto: continúa como contexto de riesgo solo para revisión. Las decisiones de control siguen en manos del asesor agronómico.",
          crop_rotation_current:
            "El asesor de rotación es solo visible. No siembra, planta ni ejecuta ninguna operación de campo.",
          crop_rotation_target:
            "Uso previsto: generar una recomendación de rotación para revisión humana. Nunca sembrará ni plantará.",
          parcel_memory_current:
            "La memoria de parcela aporta contexto histórico solo visible.",
          parcel_memory_target:
            "Uso previsto: pasar a ser evidencia histórica primaria, sin efectos sobre gates.",
          field_activities_current:
            "Las actividades de campo aportan evidencia operativa registrada por humanos, solo visible.",
          field_activities_target:
            "Uso previsto: pasar a ser evidencia operativa primaria, sin ejecución automática.",
        },
        notes: {
          drought_water_stress:
            "La sequía y el estrés hídrico son auxiliares hoy. Cualquier decisión de agua requiere revisión humana.",
          ml_risk_analysis:
            "Las salidas de riesgo ML son estimaciones no vinculantes. No confirman daño ni activan siniestros.",
          economic_risk_impact:
            "Las salidas de riesgo económico son estimaciones no vinculantes. No representan una decisión de seguros, legal ni PAC.",
          nitrogen_optimizer:
            "La guía de nitrógeno es solo para revisión. Gaucho no propone productos, dosis ni aplicaciones.",
          pk_fertilization_optimizer:
            "La guía de P y K es solo para revisión. Gaucho no propone productos, dosis ni aplicaciones.",
          irrigation_optimizer:
            "El contexto de riego es solo para revisión. Gaucho no programa ni inicia riego.",
          advanced_vegetation_analysis:
            "Los índices de vegetación son evidencia. La causa requiere validación de campo.",
          satellite_view:
            "La imagen satelital es informativa. La causa requiere validación de campo.",
          crop_seasons:
            "Los datos de temporada aportan contexto de ciclo. No habilitan gates agronómicos por sí solos.",
          phenology_gdd:
            "GDD es auxiliar. No habilita fenología, FAO-56 ni ningún otro gate hoy.",
          soil_foliar_analysis:
            "El análisis de suelo y foliar requiere revisión humana. Gaucho no diagnostica estado nutricional sin un análisis persistido.",
          reports_center:
            "Los reportes son documentos solo para revisión. Gaucho no envía acciones de seguros, legales ni PAC.",
          fire_risk:
            "El riesgo de incendio es solo para revisión. Gaucho no inicia ni despacha respuesta de emergencia.",
          pest_disease:
            "El riesgo de plagas y enfermedades es solo para revisión. Gaucho no propone productos, dosis ni aplicaciones.",
          crop_rotation_advisor:
            "El asesor de rotación es solo para revisión. Gaucho no siembra, planta ni ejecuta ninguna operación de campo.",
          parcel_memory:
            "La memoria de parcela es solo contexto histórico.",
          field_activities:
            "Las actividades de campo son evidencia registrada por humanos. Gaucho no ejecuta actividades por ti.",
        },
        blockedUses: {
          no_irrigation_execution:
            "No programa ni inicia riego.",
          no_fao56_gate_bypass: "No omite los gates de evidencia FAO-56.",
          no_gate_effect: "No afecta los gates de evidencia de Gaucho hoy.",
          no_auto_recommendation:
            "No crea recomendaciones automáticamente.",
          no_product_dose_recommendation:
            "No propone productos, dosis ni aplicaciones.",
          no_fertilizer_application_execution:
            "No ejecuta ni programa una aplicación de fertilizante.",
          no_nutrient_diagnosis_without_analysis:
            "No diagnostica estado nutricional sin un análisis persistido.",
          no_cause_inference_from_satellite:
            "No infiere la causa solo desde satélite.",
          no_claim_or_legal_submission:
            "No envía acciones de seguros, legales ni PAC.",
          no_emergency_action:
            "No inicia ni despacha una respuesta de emergencia.",
          no_product_or_dose:
            "No propone productos, dosis ni aplicaciones.",
          no_sowing_planting_execution:
            "No siembra, planta ni ejecuta ninguna operación de campo.",
          no_auto_execution: "No ejecuta actividades automáticamente.",
          blocked_from_approval:
            "No apto para aprobación supervisada. Solo seguimiento humano.",
          no_phenology_gate_unlock:
            "No habilita gates de fenología hoy.",
        },
        allowedFutureUses: {
          provide_water_context: "Aportar contexto hídrico para revisión humana.",
          trigger_water_review_recommendation:
            "Generar una recomendación de contexto hídrico para revisión humana.",
          display_non_binding_risk_context:
            "Mostrar contexto de riesgo no vinculante para revisión humana.",
          display_non_binding_economic_context:
            "Mostrar contexto económico no vinculante para revisión humana.",
          surface_review_only_fertility_context:
            "Exponer contexto de fertilidad solo para revisión.",
          surface_review_only_irrigation_context:
            "Exponer contexto de riego solo para revisión.",
          provide_vegetation_evidence:
            "Aportar evidencia de vegetación.",
          display_imagery_context: "Mostrar contexto de imagen.",
          provide_lifecycle_context: "Aportar contexto de ciclo del cultivo.",
          display_gdd_auxiliary_context:
            "Mostrar GDD como contexto auxiliar.",
          generate_review_documentation:
            "Generar documentación solo para revisión.",
          display_fire_risk_context: "Mostrar contexto de riesgo de incendio.",
          display_pest_risk_context:
            "Mostrar contexto de riesgo de plagas y enfermedades.",
          provide_rotation_advisory_for_review:
            "Aportar asesoría de rotación para revisión humana.",
          provide_historical_context: "Aportar contexto histórico.",
          record_human_operational_evidence:
            "Registrar evidencia operativa humana.",
        },
      },
      fertilityReviewContext: {
        title: "Contexto de fertilidad (solo revisión)",
        subtitle:
          "Contexto de fertilidad solo para revisión de la parcela actual. Gaucho no recomienda productos fertilizantes, dosis ni tasas de aplicación.",
        nitrogen: "Contexto de nitrógeno",
        phosphorusPotassium: "Contexto de fósforo y potasio",
        soilAnalysis: "Análisis de suelo",
        foliarAnalysis: "Análisis foliar",
        labAnalysis: "Fecha de análisis de laboratorio",
        cropStage: "Estado del cultivo",
        nutrientsFlagged: "Nutrientes marcados para revisión",
        reviewOnly: "Solo revisión",
        requiresAgronomistReview: "Requiere revisión agronómica",
        empty: "No hay contexto de fertilidad disponible.",
        notConnected:
          "Los módulos de fertilidad aún no están conectados a Gaucho. Abre el Optimizador de Nitrógeno, el Optimizador P&K y el Análisis de Suelo/Foliar para la vista completa.",
        insufficientData: "Las señales de fertilidad aún no tienen datos suficientes.",
        statuses: {
          available: "Disponible",
          insufficient_data: "Datos insuficientes",
          not_available: "No disponible",
          not_connected: "No conectado",
          error: "Error en la fuente de datos",
          connected_review_only: "Conectado · solo revisión",
        },
        connectedEvidenceNote:
          "Esta evidencia existe y está conectada al Contexto de Fertilidad, pero aquí no se verifica como evidencia confirmada de laboratorio. Sigue siendo solo de revisión y no habilita recomendaciones de fertilidad.",
        soilEvidenceTiers: {
          producer_lab_attributed:
            "Atribuido a laboratorio por el productor · solo revisión",
          producer_declared: "Declarado por el productor · sin verificar",
          unattributed: "Referencia modelada · no es evidencia del productor",
          absent: "No disponible",
        },
        unattributedSoilNote:
          "El registro de suelo almacenado para esta parcela no tiene atribución del productor ni de laboratorio (sin nombre de laboratorio, fecha de muestreo, profundidad de muestreo ni documento de laboratorio). Son datos modelados de referencia y no cuentan como evidencia de suelo del productor.",
        summary: {
          both: "El contexto de nitrógeno y P&K está visible como señal solo de revisión.",
          nitrogenOnly:
            "El contexto de nitrógeno está visible como señal solo de revisión. El contexto P&K no está conectado.",
          pkOnly:
            "El contexto P&K está visible como señal solo de revisión. El contexto de nitrógeno no está conectado.",
          insufficient:
            "Las señales de fertilidad aún no tienen datos suficientes. Se requiere revisión agronómica cualificada.",
          notConnected:
            "Los módulos de fertilidad aún no están conectados a Gaucho.",
          empty: "No hay contexto de fertilidad disponible.",
        },
        missing: {
          nitrogen: "La salida del Optimizador de Nitrógeno no está conectada a Gaucho.",
          pk: "La salida del Optimizador P&K no está conectada a Gaucho.",
          soilAnalysis: "No disponible",
          foliarAnalysis: "No disponible",
          soilOrFoliarEvidence:
            "Se requiere evidencia de suelo o foliar para decisiones de fertilidad.",
        },
        safety: {
          title: "Aviso de seguridad",
          reviewOnly: "El contexto de fertilidad es solo para revisión.",
          noProductDoseApplicationRate:
            "Gaucho no recomienda productos fertilizantes, dosis ni tasas de aplicación.",
          requiresLabAndAgronomistReview:
            "Se requiere evidencia de suelo o foliar y revisión agronómica cualificada.",
          noSatelliteOnlyDeficiencyInference:
            "No se infiere ninguna deficiencia de nutrientes solo a partir de datos satelitales.",
        },
      },
      riskEconomicContext: {
        title: "Contexto de riesgo e impacto económico",
        subtitle:
          "Contexto no vinculante de apoyo a la decisión para la parcela actual. Solo revisión.",
        mlRisk: "Contexto de riesgo ML",
        economicImpact: "Contexto de impacto económico",
        confidence: "Confianza del modelo",
        historicalCoverage: "Cobertura histórica",
        claimsRecords: "Registros históricos de siniestros",
        yieldRecords: "Registros históricos de rendimientos",
        estimatedImpact: "Impacto económico estimado",
        estimatedRange: "Rango estimado",
        nonBinding: "No vinculante",
        requiresHumanReview: "Requiere revisión humana",
        empty: "No hay contexto de riesgo o impacto económico disponible.",
        notConnected:
          "Los módulos de riesgo e impacto económico aún no están conectados a Gaucho. Abre los módulos de Análisis de Riesgo ML e Impacto Económico para la vista completa.",
        confidenceLabels: {
          high: "Alta",
          medium: "Media",
          low: "Baja",
          unknown: "Desconocida",
        },
        riskLevel: {
          title: "Nivel de riesgo",
          low: "Bajo",
          medium: "Medio",
          high: "Alto",
          unknown: "Desconocido",
        },
        impactLevel: {
          title: "Nivel de impacto",
          low: "Bajo",
          medium: "Medio",
          high: "Alto",
          unknown: "Desconocido",
        },
        statuses: {
          available: "Disponible",
          insufficient_data: "Datos insuficientes",
          not_available: "No disponible",
          error: "Error en la fuente de datos",
          not_connected: "No conectado",
        },
        summary: {
          both: "El contexto de riesgo ML y de impacto económico está disponible como señal solo de revisión.",
          mlOnly:
            "El contexto de riesgo ML está disponible como señal solo de revisión. El contexto de impacto económico no está conectado.",
          economicOnly:
            "El contexto de impacto económico está disponible como señal solo de revisión. El contexto de riesgo ML no está conectado.",
          insufficient:
            "Las señales de riesgo e impacto económico aún no tienen datos suficientes. Requiere revisión antes de cualquier decisión.",
          notConnected:
            "Los módulos de riesgo e impacto económico aún no están conectados a Gaucho.",
          empty: "No hay contexto de riesgo o impacto económico disponible.",
        },
        missing: {
          mlRisk: "No hay contexto de riesgo ML conectado a Gaucho.",
          economicImpact:
            "No hay contexto de impacto económico conectado a Gaucho.",
        },
        safety: {
          title: "Aviso de seguridad",
          decisionSupportOnly:
            "El riesgo y el impacto económico son estimaciones de apoyo a la decisión.",
          doesNotConfirmLoss:
            "No confirman pérdidas ni validan reclamaciones.",
          noClaimSubmission:
            "No se envía ninguna acción legal, de seguro, reclamación ni emergencia.",
          requiresQualifiedReview:
            "Requiere revisión humana cualificada antes de cualquier decisión.",
        },
      },
    },
    waterDeficit: {
      reviewOnly: "Solo revisión",
      supporting: "Evidencia compatible con un déficit hídrico",
      contradicting: "Evidencia que no indica déficit hídrico",
      modifiers: "Contexto considerado",
      reviewActions: "Pasos de revisión sugeridos",
      missing: "Evidencia faltante",
      referenceDemandNote:
        "Demanda hídrica de referencia del cultivo FAO-56 (Kc único): {{etc}} mm/día. Es demanda, no un déficit medido.",
      forecastNote:
        "Precipitación prevista en la ventana cubierta: {{mm}} mm (hasta {{days}}).",
      providerReferenceNote:
        "La humedad de zona radicular de NASA POWER se muestra solo como referencia externa. No es evidencia canónica, no participa en el razonamiento y se descartan su nivel de estrés y su consejo de riego.",
      amountGuidanceNote:
        "Las cantidades de riego y las recomendaciones supervisadas siguen gobernadas por la puerta de preparación de riego FAO-56. Gaucho nunca programa ni ejecuta riego.",
      pattern: {
        CONVERGING_WATER_DEFICIT_CONCERN: {
          headline: "Fuentes independientes convergen en un posible déficit hídrico",
          reasoning:
            "Más de una fuente independiente es compatible con un déficit hídrico y ninguna lo contradice. Esto no demuestra un déficit en la zona radicular; valide en campo antes de cualquier decisión de riego.",
        },
        PARTIAL_WATER_DEFICIT_CONCERN: {
          headline: "Una fuente directa es compatible con un déficit hídrico",
          reasoning:
            "Una sola fuente directa es compatible con un déficit hídrico. Las demás fuentes no lo han confirmado.",
        },
        SATELLITE_SIGNAL_CAUSE_UNRESOLVED: {
          headline: "Señal satelital detectada, causa no resuelta",
          reasoning:
            "La señal del dosel es compatible con estrés hídrico, pero no hay balance hídrico de zona radicular disponible, por lo que la causa no puede atribuirse al agua. No se descartan causas de nutrición, plagas, enfermedades o manejo.",
        },
        DEMAND_WITHOUT_STRESS_SIGNAL: {
          headline: "Demanda de referencia disponible, sin señal de estrés",
          reasoning:
            "La demanda de referencia FAO-56 está disponible, pero ninguna fuente directa indica estrés hídrico del cultivo. La demanda por sí sola nunca es un déficit.",
        },
        MIXED_OR_CONFLICTING_WATER_EVIDENCE: {
          headline: "La evidencia hídrica requiere reconciliación",
          reasoning:
            "Las fuentes discrepan, o un aporte de agua reciente coexiste con una señal de déficit persistente. Un aporte reciente no demuestra que el déficit se haya resuelto.",
        },
        NO_CURRENT_CONVERGING_WATER_DEFICIT_SIGNAL: {
          headline: "Sin señal convergente de déficit hídrico ahora mismo",
          reasoning:
            "Todas las fuentes directas resueltas son actualmente coherentes con un estado hídrico adecuado.",
        },
        INSUFFICIENT_EVIDENCE: {
          headline: "Evidencia hídrica insuficiente para razonar",
          reasoning:
            "No se resolvió ninguna fuente hídrica directa para esta parcela. Complete la evidencia faltante en los módulos existentes.",
        },
      },
      channel: {
        single_kc_reference_demand: "Demanda hídrica de referencia FAO-56 (Kc único)",
        canonical_root_zone_balance: "Balance hídrico de zona radicular FAO-56 (Kc dual)",
        modelled_reference_soil_water_balance: "Balance hídrico del suelo modelizado",
        satellite_water_stress: "Señal hídrica del dosel Sentinel-2 (NDWI/NDVI)",
        drought_context: "Contexto regional de sequía",
        water_alerts: "Alertas hídricas registradas",
      },
      modifier: {
        recent_precipitation_observed: "Precipitación observada en el periodo registrado",
        explicit_zero_precipitation_observed:
          "Sin precipitación registrada en el periodo observado",
        observed_precipitation_unknown:
          "Precipitación observada desconocida para este periodo",
        near_term_precipitation_expected: "Precipitación prevista en la ventana de pronóstico",
        no_precipitation_forecast_for_covered_period:
          "Sin precipitación prevista en la ventana cubierta",
        forecast_precipitation_unknown: "Precipitación prevista no disponible o incompleta",
        recent_irrigation_observed_response_not_yet_verified:
          "Riego reciente registrado; la respuesta del cultivo aún no se ha verificado",
        applied_irrigation_uncertain: "Riego aplicado reportado como incierto",
        no_irrigation_confirmed: "El productor confirmó que no se aplicó riego",
        irrigation_log_missing: "Sin registro de riego aplicado en esta ventana",
      },
      action: {
        validate_water_status_in_field: "Valide el estado hídrico en campo",
        review_canonical_water_balance_before_any_irrigation_decision:
          "Revise el balance hídrico canónico antes de cualquier decisión de riego",
        review_applied_irrigation_log: "Revise el registro de riego aplicado",
        rule_out_non_water_causes_of_the_satellite_signal:
          "Descarte causas no hídricas de la señal satelital (nutrición, plagas, enfermedades, manejo)",
        complete_canonical_root_zone_balance_evidence:
          "Complete la evidencia del balance de zona radicular FAO-56",
        monitor_reference_crop_demand_and_crop_condition:
          "Monitorice la demanda de referencia y el estado del cultivo",
        reconcile_conflicting_water_evidence_channels:
          "Reconcilie las fuentes de evidencia hídrica en conflicto",
        continue_routine_monitoring: "Continúe con el monitoreo rutinario",
        complete_missing_water_evidence_via_existing_modules:
          "Complete la evidencia hídrica faltante en los módulos existentes",
      },
      evidence: {
        water_stress_evidence: "evidencia hídrica",
        single_kc_reference_demand: "demanda hídrica de referencia FAO-56",
        canonical_root_zone_balance: "balance hídrico de zona radicular FAO-56",
        canonical_soil_water_balance: "balance hídrico del suelo canónico",
        recent_satellite_water_signal: "señal hídrica satelital reciente",
        observed_precipitation: "precipitación observada",
        forecast_precipitation: "precipitación prevista",
        irrigation_log: "registro de riego aplicado",
      },
    },
  },
};
export type AdvisorEs = typeof advisorEs;